// React+Webpack Implementation of Reports
// Enable diagnostic timing by setting reportperf=1 in dev console.

/* global AmCharts, L, reportModule, reportperf */
/* eslint-disable one-var */
/* eslint-disable one-var-declaration-per-line */
/* eslint-disable no-eval */
/* eslint-disable no-new */
/* eslint-disable @typescript-eslint/no-throw-literal */

// npm imports
import React from 'react';
import $ from 'jquery';
import _ from 'lodash';
import { AllModules, LicenseManager } from '@ag-grid-enterprise/all-modules';
import { Grid } from '@ag-grid-community/core';
import Clipboard from 'clipboard';
import Flickity from 'flickity';
import hash from 'object-hash';
import moment from 'moment';
import printJS from 'print-js';
import { Alert } from 'react-bootstrap';
import RModal from 'rmodal/index';
import { v4 as uuidv4 } from 'uuid';
import wordwrap from 'word-wrap';
import tinyColor from 'tinycolor2';

// npm imports styles
import 'flickity/css/flickity.css';
import 'mapbox.js/dist/mapbox.css';

// commercial amcharts - different fron npm version
import '@dsisolutions/amcharts/amcharts';
import '@dsisolutions/amcharts/pie';
import '@dsisolutions/amcharts/radar';
import '@dsisolutions/amcharts/serial';
import '@dsisolutions/amcharts/themes/material';

// This required turning off the autoload of dependent libs within the export plugin to prevent errors.
import 'fabric'; // amcharts v3 export depends on 1.x
import 'file-saver'; // works with v1 or v2
import '@dsisolutions/amcharts/plugins/export/export.js';
import '@dsisolutions/amcharts/plugins/export/export.css';
import exportAmChartsConfig from './ExportAmChartsConfig';

// custom imports
import store from '../../store';
import toastr from '../toastr';
import Api from '../../services/ApiService';
import Drilldown from './ReportDrilldownController';
import Pikaday from './vendor/pikaday/pikaday-dsi'; // DSI patched to resolve focus bug
import { DateComparator, SmartSortComparator, StatusCodeComparator } from '../../util/grid';
import { modal } from '../modal/ModalEmitter';
import SaveGridLayoutForm from '../grid/SaveGridLayoutForm';
import LoadGridLayoutForm from '../grid/LoadGridLayoutForm';

// custom imports styles
import '../../styles/vendor/bootstrap-select/bootstrap-select.css';
import '../../styles/vendor/bootstrap-tagsinput/bootstrap-tagsinput-typeahead.css';
import '../../styles/vendor/bootstrap-tagsinput/bootstrap-tagsinput.css';
import '../../styles/vendor/pikaday/pikaday.css';

// webpack AmCharts images, then set pathToImages on AmCharts object as /img/amcharts/
require.context('!!file-loader?name=img/amcharts/[name].[ext]!@dsisolutions/amcharts/images');

// mapbox npm version, adds "L" to the global object
require('mapbox.js');

// jquery plugins
window.jQuery = $;
require('./vendor/bootstrap-select/dropdown'); // before bootstrap-select
require('./vendor/bootstrap-select/bootstrap-select');
require('./vendor/bootstrap-tagsinput/typeahead.jquery'); // before-bootstrap-tagsinput
require('./vendor/bootstrap-tagsinput/bootstrap-tagsinput');

LicenseManager.setLicenseKey(
  'CompanyName=DSI Solutions LLC,LicensedApplication=Databridge,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-034220,SupportServicesEnd=11_December_2023_[v2]_MTcwMjI1MjgwMDAwMA==d1279f3c2b74c7329f0c6ce905dae788'
);
L.mapbox.accessToken = 'pk.eyJ1IjoiZHNpIiwiYSI6ImNpZXZnbWV6bjB3ZmFzOW0yYThmMHNndnQifQ.QuZgncRxvvXe0AXcnG22GQ';

// Module state - see init() for default values and docs, reset on each mount
let alternateBranchesRequested,
  activeLayoutId,
  autoExpand,
  autoRefreshSecs,
  autoRefreshIntervalObj,
  averageAggregations,
  bsSelectObjs,
  bsTagsObjs,
  cacheDisabled,
  chartObjs,
  clipboard,
  columnDefs,
  dataLinesAggregate,
  dollarsignDisabled,
  downloadPDFinProgress,
  dynamicReport,
  geocodes,
  graphsToggled,
  gridOptions,
  hasArchive,
  hasVisibleOptions,
  headerHeight,
  headersToggledFromDefaultConfig,
  highlightSecs,
  itemId,
  mapboxObjs,
  mismatches,
  multibranchAvailable,
  multibranchDisabled,
  optionsModalShowing,
  pikaDayObjs,
  pinnedBottomRowData,
  rangecharts,
  reloadPageOnRerun,
  reportAverageAggregations,
  reportTotalAggregations,
  reportConfig,
  reportModalConductorDiv,
  reportNameInput,
  reportOptions,
  rowCount,
  rowData,
  rowDataTyped,
  rowHeightOverride,
  seededOptionsFromUserProfile,
  shareModalShowing,
  shopStatusLocationEditError,
  shopStatusPromisedEditError,
  sortingDisabled,
  sparklinePresent,
  subsequentReportRun,
  totalAggregations,
  user,
  usingShareLink,
  verticalHeadersDefault,
  waitingInterval,
  zipcodes;

// DOM objects not available until the report react component mounts - see init()
let actionButtonsDiv,
  cancelOptionsButton,
  deleteLayoutButton,
  firstOptionEl,
  graphsButton,
  graphsContainer,
  gridDiv,
  noDataDiv,
  layoutMenuHeader,
  optionsSetDiv,
  optionsForm,
  optionsModalDiv,
  quickFilterDiv,
  quickFilterInput,
  refreshNotificationSpan,
  rowCountSpan,
  searchClearButton,
  shareLinkInput,
  shareModalDiv,
  showOptionsButton,
  waitingDiv,
  waitingBranch,
  waitingSecs;

// rmodal Objects
let optionsModal, shareModal;

const promiseIDs = new Map(); // track executing promises for emulated cancel-ability (API calls)

// these get populated via eval'd widget files (server/views/widgets)
const renderHooks = {},
  sparklineOptions = {},
  styleHooks = {},
  widgets = {};

// Reports that could have RO status, location columns
const roReports = [
  'WEBRO2',
  'WEBRO2A',
  'WEBRO3',
  'SRO1',
  'SRO2',
  'SRO3',
  'SRO4',
  'SRO5',
  'SRO9',
  'SRO10',
  'SRO12',
  'ACL2',
  'SML9',
];

// Status Code Ag Grid Methods
const statusCodeCellStyle = params => {
  let style = { 'background-color': 'transparent' };
  const { codes } = store.getState().app;
  // look at params.value and match it to a color in reportConfig.statusCodes if it exists (exact match)
  const codeIndex = _.findIndex(codes, o => o.id === parseInt(params.value));

  if (codeIndex !== -1) {
    const { color } = codes[codeIndex];
    style = {
      'background-color': color,
      color: tinyColor(color).isDark() ? '#FFF' : '#333',
    };
  }
  return style;
};

const statusCodeValueFormatter = params => {
  const { codes } = store.getState().app;

  const code = _.find(codes, o => o.id === parseInt(params.value));

  if (code) {
    return code.name;
  }

  return params.value;
};

// used on .xls exports
const excelStyles = [
  {
    id: 'header', // pre-defined ID for headers
    font: { bold: true, color: '#FFFFFF', size: 11 },
    interior: { color: '#2196F3', pattern: 'Solid' },
  },
  {
    id: 'xls-currency',
    font: { size: 11 },
    numberFormat: { format: '#,##0.00' },
  },
  {
    id: 'xls-doubleFourPlaces',
    font: { size: 11 },
    numberFormat: { format: '0.0000' },
  },
  {
    id: 'xls-doubleTwoPlaces',
    font: { size: 11 },
    numberFormat: { format: '0.00' },
  },
  {
    id: 'xls-integer',
    font: { size: 11 },
    numberFormat: { format: '0' },
  },
  {
    id: 'xls-string',
    font: { size: 11 },
    dataType: 'string',
  },
];

function hide(element) {
  element.style.display = 'none';
}

function show(element, display = 'block') {
  element.style.display = display;
}

function currencyValueFormatter(params) {
  let renderString = '';
  if (params.value === null || params.value === undefined || params.value === '') {
    renderString = null;
  } else if (isNaN(params.value)) {
    renderString = 'NaN';
  } else if (params.node.group && params.column.aggFunc === 'count') {
    // if we are doing 'count', then we do not show dollar sign
    renderString = params.value;
  } else {
    renderString = `${dollarsignDisabled ? '' : '$'}${numberWithCommas(
      params.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    )}`;
  }

  return renderString;
}

function doubleValueFormatter(params) {
  const precision = _.get(params, 'colDef.precision', 2);
  let renderString = '';
  if (params.value === null || params.value === undefined || params.value === '') {
    renderString = null;
  } else if (isNaN(params.value)) {
    renderString = 'NaN';
  } else {
    // unlike toFixed, toLocaleString works on numbers and strings (aggregation row values)
    renderString = params.value.toLocaleString('en-US', {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    });
  }

  return renderString;
}

// listeners added when component mounts, removed when unmounts
// shared between init() and destroy(), so global to this module
function eventListenerModalEscape(event) {
  if (event.key === 'Escape') {
    if (optionsModalShowing) {
      optionsModal.close();
    }
    if (shareModalShowing) {
      shareModal.close();
    }
  }
}

function eventListenerWindowResize() {
  autoSizeGrid();
}

/** init()
 ** Called when react component mounts.  Resets the report runner to a fresh state.
 */
function init(opts) {
  // user holds branch affiliation info and such used for multi-branch reports
  ({ hasArchive, user } = opts);

  // init state
  activeLayoutId = null;
  alternateBranchesRequested = false;
  autoExpand = false; // auto expand when grouping
  autoRefreshSecs = 0; // # of seconds to poll for new data, optionally specified in YAML. 0 = disabled
  autoRefreshIntervalObj = null;
  averageAggregations = {}; // overall report aggs calculated once on inital data load
  bsSelectObjs = []; // holds references to bootstrap-select controls (for cleanup)
  bsTagsObjs = []; // holds references to bootstrap-tags search controls (for cleanup)
  cacheDisabled = false; // determined via YAML for each report: page.Report.cache.disabled
  chartObjs = []; // holds references to all rendered amcharts (for creation/cleanup) & associated data transformers
  columnDefs = null; // shared among ag-grid methods
  dataLinesAggregate = [];
  dollarsignDisabled = false;
  dynamicReport = false;
  firstOptionEl = null; // first input element on an option modal
  geocodes = null;
  graphsToggled = false; // graphs hidden on load - used to track when grid should resize, as well
  gridOptions = null; // ag-grid is controlled via gridOptions.columnApi & gridOptions.api
  hasVisibleOptions = false;
  headerHeight = null; // null unless verticalheaders:true, defaults to 150px unless overridden with verticalheaderheight
  highlightSecs = 5; // # of seconds for change highlight to remain on screen
  headersToggledFromDefaultConfig = false; // has the user changed header orientation from the YAML specification via toggle?
  itemId = undefined; // used for cell changes feature
  mapboxObjs = []; // similar to chartObjs, holds references to any rendered maps for cleanup
  mismatches = []; // helps debug mismatches
  multibranchAvailable = false; // if multibranch is enabled AND the user has access on other branches (calculated)
  multibranchDisabled = false; // allow only active branch for user (YAML override specified)
  optionsModalShowing = false;
  pikaDayObjs = []; // shared for creation/destruction of objects
  pinnedBottomRowData = [];
  rangecharts = true;

  // If a new layout is saved or a layout deletion occurs in a session, reload the page on report rerun so the
  // layout is added/removed from the report options modal.  This is much simpler than injecting additions/deletions
  // into the rendered options modal.
  reloadPageOnRerun = false;

  reportAverageAggregations = false; // overall report aggregations display (not per column)
  reportTotalAggregations = false;
  reportConfig = null; // .reportName/.config (essentially an obj version of the YAML)
  reportOptions = []; // user specified report options
  rowCount = 0; // displayable row count
  rowData = []; // holds the displayed row data
  rowDataTyped = []; // rowData is all strings for grid display, rowDataTyped maintains types (widgets, etc.)
  rowHeightOverride = undefined;
  seededOptionsFromUserProfile = false; // tracks if seed options were retrieved from the user's profile
  shareModalShowing = false;
  shopStatusLocationEditError = false;
  shopStatusPromisedEditError = false;
  sortingDisabled = false;
  sparklinePresent = false;
  subsequentReportRun = false; // user presses the Options/Re-Run button
  totalAggregations = {}; // overall report aggs calculated once on inital load, shared among functions
  usingShareLink = false;
  verticalHeadersDefault = false;
  waitingInterval = null; // shared for show/hide
  zipcodes = null;

  // Mount the report modal conductor into the DOM
  reportModalConductorDiv = document.createElement('div');
  reportModalConductorDiv.id = 'report-module-modal-conductor';
  reportModalConductorDiv.innerHTML = `
    <div id="drilldownModalDiv" class="modal" style="z-index:100">
      <div class="modal-dialog" id="drilldownModalContent"></div>
    </div>
    <div id="drilldownSubModalDiv" class="modal" style="z-index:200">
      <div class="modal-dialog" id="drilldownSubModalContent"></div>
    </div>
  `;
  document.getElementById('app').appendChild(reportModalConductorDiv);

  // init DOM objects this module interacts with - available only after react component mounts
  actionButtonsDiv = document.getElementById('actionButtonsDiv');
  cancelOptionsButton = document.getElementById('cancelOptionsButton');
  deleteLayoutButton = document.getElementById('deleteLayoutButton');
  graphsButton = document.getElementById('graphsButton');
  graphsContainer = document.getElementById('graphsContainer');
  gridDiv = document.getElementById('gridDiv');
  layoutMenuHeader = document.getElementById('layoutMenuHeader');
  noDataDiv = document.getElementById('noDataDiv');
  optionsForm = document.getElementById('optionsForm');
  optionsModalDiv = document.getElementById('optionsModalDiv');
  optionsSetDiv = document.getElementById('optionsSetDiv');
  quickFilterDiv = document.getElementById('quickFilterDiv');
  quickFilterInput = document.getElementById('quickFilterInput');
  refreshNotificationSpan = document.getElementById('refreshNotificationSpan');
  rowCountSpan = document.getElementById('rowCountSpan');
  searchClearButton = document.getElementById('searchClearButton');
  shareLinkInput = document.getElementById('shareLinkInput');
  shareModalDiv = document.getElementById('shareModalDiv');
  showOptionsButton = document.getElementById('showOptionsButton');
  waitingBranch = document.getElementById('waitingBranch');
  waitingDiv = document.getElementById('waitingDiv');
  waitingSecs = document.getElementById('waitingSecs');

  promiseIDs.clear();

  // tabbing after cancel button?  cycle back to first option
  function eventListenerOptionsModalTab(event) {
    if (event.which === 9 && !event.shiftKey) {
      event.preventDefault();
      firstOptionEl.focus(); // firstOptionEl dynamically set afterOpen() of options modal
    }
  }

  // shift tabbing out of first option?  cycle back to cancel button
  function eventListenerOptionsModalShiftTab(event) {
    if (event.which === 9 && event.shiftKey) {
      event.preventDefault();
      cancelOptionsButton.focus();
    }
  }

  optionsModal = new RModal(optionsModalDiv, {
    closeTimeout: 0,
    focus: true,
    escapeClose: false,
    afterOpen() {
      // capture tab/shift+tab
      firstOptionEl = document.activeElement; // changes throughout life of SPA
      if (firstOptionEl === null) {
        // no report options exist, cache option only
        firstOptionEl = document.getElementById('useCache');
        // in the case of no visible options and disabled cache, this modal won't show anyway
      }
      firstOptionEl.addEventListener('keydown', eventListenerOptionsModalShiftTab);
      cancelOptionsButton.addEventListener('keydown', eventListenerOptionsModalTab);
      optionsModalShowing = true;
    },
    afterClose() {
      pikaDayHide(); // necessary for removing visible calendars on esc of modal
      if (optionsModalShowing) {
        firstOptionEl.removeEventListener('keydown', eventListenerOptionsModalShiftTab);
        cancelOptionsButton.removeEventListener('keydown', eventListenerOptionsModalTab);
      }
      optionsModalShowing = false;
    },
  });

  shareModal = new RModal(shareModalDiv, {
    closeTimeout: 0,
    escapeClose: false,
    focus: true,
    afterOpen() {
      shareModalShowing = true;
    },
    afterClose() {
      shareModalShowing = false;
    },
  });

  // init clipboard.js for link sharing
  clipboard = new Clipboard('#shareClipboardButton');
  clipboard.on('success', () => {
    shareModal.close();
    toastr.success('Success!', 'Report link copied to clipboard.');
  });

  // removed on destroy()
  document.addEventListener('keydown', eventListenerModalEscape);
  window.addEventListener('resize', eventListenerWindowResize);

  // init the drilldown module (react component is mounted now)
  Drilldown.init();

  reportNameInput = opts.reportName.toUpperCase(); // from react infrastructure

  // check for share link to auto-run report & preload options
  // logic ignores reportName in URL if opts are provided
  // also would ignore any persisted report options
  if (~window.location.search.indexOf('?opts=')) {
    shareLinkRun();
  } else {
    showOptions();
  }
}

/** destroy()
 ** Called when react component unmounts.
 */
function destroy() {
  // cancel any pending API calls
  promiseIDs.clear();

  // close / destroy any currently open modals if user presses back button
  shareModal.close();
  optionsModal.close();

  // cleanup clipboard (listeners, etc.)
  clipboard.destroy();

  // turn off any currently processing waiting indicator
  waitingIndicator(false);

  clearInterval(autoRefreshIntervalObj);

  document.removeEventListener('keydown', eventListenerModalEscape);
  window.removeEventListener('resize', eventListenerWindowResize);

  // cleanup ag-grid resources
  if (gridOptions !== null) {
    gridOptions.api.destroy();
    gridOptions = null;
  }

  // cleanup pikaday resources
  pikaDayObjs.forEach(pikaDayObj => {
    pikaDayObj.destroy();
  });
  pikaDayObjs = [];

  // cleanup bootstrap-select resources
  bsSelectObjs.forEach(bsSelectObj => {
    $(`#${bsSelectObj}`).selectpicker('destroy');
  });
  bsSelectObjs = [];

  // cleanup bootstrap-tags resources - tagsinput doesn't cleanup typeahead
  bsTagsObjs.forEach(bsTagsObj => {
    $(`#${bsTagsObj.id}`).typeahead('destroy');
    $(`#${bsTagsObj.id}`).tagsinput('destroy');
  });
  bsTagsObjs = [];

  // cleanup any amchart/mapbox resources
  clearGraphs();

  // cleanup any resources used by drilldowns (date pickers, charts, etc.)
  Drilldown.destroy();

  // unmount report modal "conductor"
  document.getElementById('app').removeChild(reportModalConductorDiv);
}

/* ************************************************************
 *  After this point, all functions will be listed alphabetically.
 *  *************************************************************
 */

/* Custom aggregation functions must be registered and applied AFTER the grid
   is initialized, otherwise ag-Grid throws exceptions to the console.
   This must be re-applied after any form of column reset as well.

   aggFuncs cannot be directly applied to the columnDefs as, while they appear
   to work initially when grouping, they will be lost after any column reset occurs.
*/
function applyAggFuncs() {
  const columnState = gridOptions.columnApi.getColumnState();
  for (let i = 0; i < columnState.length; i++) {
    const columnDefsIndex = _.findIndex(columnDefs, o => o.field === columnState[i].colId);
    columnState[i].aggFunc = columnDefs[columnDefsIndex].aggFuncToApply;
  }
  gridOptions.columnApi.applyColumnState({ state: columnState });
}

// type is 'csv', 'xlsx', or 'xls'
async function archive(type) {
  const branchId = user.defaultBranch.id;
  try {
    switch (type) {
      case 'csv':
        const data = gridOptions.api.getDataAsCsv({
          prependContent: exportTitleHeader({ includeDate: true, includeOptions: true, isCSV: true }),
          processCellCallback: exportProcessCellCallback,
        });

        await Api.post('archive/report', {
          branchId,
          data,
          ext: 'csv',
          pageName: reportConfig.reportName,
        });

        break;
      case 'xls':
        // todo
        break;
      case 'xlsx':
        // todo
        break;
      default:
        break;
    }

    toastr.success('Success', 'Sent to archive');
  } catch (e) {
    toastr.error('Error', e.message);
  }
}

/* This function is used as a setInterval callback, setup in showResults() if the
   YAML specifies this report should auto refresh its data every x seconds.

   It temporarily suspends the interval until new data is done loading.  Afterall,
   if an interval was shorter than the time it took to pull new data, we'd get
   continually behind.
*/
function autoRefreshFunc() {
  if (dynamicReport) {
    console.warn('Auto refresh is not supported for dynamic reports.');
    clearInterval(autoRefreshIntervalObj); // don't keep trying
    return;
  }

  if (document.visibilityState === 'hidden') {
    return;
  }

  clearInterval(autoRefreshIntervalObj); // pause interval until refresh data loaded
  refreshNotificationSpan.style.display = 'inline';

  // pull new data and put it in the grid
  // note an autorefresh should NOT use the report cache feature - pass true to fetchReportData
  fetchReportData(true)
    .then(res => {
      if (res !== 'NO DATA') {
        // Are we using an itemId column as a key to track additions / updates / removals (such as ro #)?
        // If so, we can apply granular updates with change highlight support.
        if (gridOptions.getRowNodeId) {
          const rowIds = {};

          // Additions & Updates
          for (const row of rowData) {
            rowIds[row[itemId]] = true;
            const rowNode = gridOptions.api.getRowNode(row[itemId]);
            if (rowNode) {
              gridOptions.api.applyTransactionAsync({ update: [row] });
            } else {
              gridOptions.api.applyTransactionAsync({ add: [row] });
            }
          }

          // Removals
          gridOptions.api.forEachNode(rowNode => {
            if (!rowIds[rowNode.id]) {
              gridOptions.api.applyTransactionAsync({ remove: [rowNode.data] });
            }
          });

          // If we're not using an itemId column/key, blast it all away and reset the row data.
        } else {
          const filterModel = gridOptions.api.getFilterModel();
          gridOptions.api.setRowData(rowData); // gridOptions.api.getModel() reflects changes after this!
          gridOptions.api.setFilterModel(filterModel); // calls onFilterChanged()
        }
      }

      refreshNotificationSpan.style.display = 'none';
      // restart interval now that new data has been loaded

      autoRefreshIntervalObj = setInterval(autoRefreshFunc, autoRefreshSecs * 1000);
    })
    .catch(() => {
      console.error('Error Auto Refreshing Data');
      refreshNotificationSpan.style.display = 'none';
      autoRefreshIntervalObj = setInterval(autoRefreshFunc, autoRefreshSecs * 1000);
    });
}

/* This function sizes the graph taking into account the size of the viewport such that the
   grid docks itself to the bottom of the viewport (maximizing the viewable height).  This is better
   than letting the grid show all rows, as this isn't performant on large data sets.

   Once (if) graphs are displayed, the auto resizing mechanism is disabled and stays locked at whatever
   size the grid was when the graphs were displayed.
*/
function autoSizeGrid() {
  if (!graphsToggled) {
    calculateGridHeight();
  }
}

// This enables a resizing similar to double clicking column header separators in excel
function autoSizeColumns() {
  gridOptions.columnApi.autoSizeAllColumns();
}

// Allows the user to quickly clear all column and quick filters in one shot
function clearAllFilters() {
  gridOptions.api.setFilterModel(null);
  clearQuickFilter();
}

// Clears any form errors on change (until revalidated)
function clearError(id) {
  const formError = document.getElementById(`formError${id}`);
  formError.style.display = 'none';
  formError.innerHTML = '';
}

function clearGraphs() {
  if (graphsToggled) {
    graphsToggled = false;
    graphsContainer.style.display = 'none';

    // cleanup any chart resources
    chartObjs.forEach(chartObj => {
      chartObj.chart.clear(); // clear up amcharts resources
      chartObj.chart = null;
    });
    chartObjs = [];

    // cleanup any mapbox resources
    mapboxObjs.forEach(mapboxObj => {
      mapboxObj.map.remove();
    });
    mapboxObjs = [];

    graphsContainer.innerHTML = '';
    autoSizeGrid(); // restore GRID back to occupy free viewport space after GRAPH removed
  }
}

// User has evented the clear quick filter button
function clearQuickFilter() {
  quickFilterInput.value = '';
  quickFilter('');
}

// Ask the API to delete any saved layout in the user.data model (user profile).
function deleteLayout() {
  if (!reportConfig.userSettings.layout) {
    // no layout loaded
    return;
  }

  modal.confirm({
    title: 'Delete Layout Confirmation',
    message: 'This will delete your layout. Are you sure?',
    confirmLabels: ['Delete', 'Cancel'],
    callback: () => {
      Api.delete(`grid-layouts/${reportConfig.userSettings.layout.id}`)
        .then(() => {
          reloadPageOnRerun = true;
          resetGrid();
          if (headersToggledFromDefaultConfig) {
            toggleVerticalHeaders();
          }
          setActiveLayout(null);
          toastr.success('Success!', 'Report layout deleted.');
        })
        .catch(() => {
          toastr.error('Error!', 'Network error.  Please try again later.');
        });
    },
  });
}

// reportModule.debug() from console window
function debug() {
  return {
    activeLayoutId,
    columnDefs,
    gridOptions,
    hasArchive,
    mismatches,
    reportConfig,
    reportOptions,
    rawData: dataLinesAggregate,
    rowDataGridDisplay: rowData,
    rowDataTyped,
    user,
  };
}

function exportProcessCellCallback(params) {
  const valueType = _.get(params, 'column.colDef.valueType', null);
  let value = params.value;

  switch (valueType) {
    case 'currency':
      if (value !== undefined) {
        value = numberWithCommas(
          params.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        );
      }
      break;
    case 'statusCode':
      if (value !== undefined) {
        const codes = getShopStatusCodes();
        const code = codes.find(c => c.id === parseInt(value));
        if (code) {
          value = code.name;
        }
      }
      break;
    case 'double':
      // params.value already has floating point precision applied which we can write directly to the
      // CSV file, however, Excel truncates certain values regardless of the underlying value in the CSV file.
      // So 0.0000 appears as 0, 0.0200 appears as .02, etc.. This cannot be overridden.
      // Both Libre and Office Excel do this.
      break;
    default:
      break;
  }
  return value;
}

function exportProcessCellXLSCallback(params) {
  const valueType = _.get(params, 'column.colDef.valueType', null);
  let value = params.value;

  switch (valueType) {
    case 'statusCode':
      if (value !== undefined) {
        const codes = getShopStatusCodes();
        const code = codes.find(c => c.id === parseInt(value));
        if (code) {
          value = code.name;
        }
      }
      break;
    default:
      break;
  }
  return value;
}

// Generates a CSV client side based on the current filters
function exportCSV() {
  const header = exportTitleHeader({ includeOptions: true, includeDate: true, isCSV: true });
  gridOptions.api.exportDataAsCsv({
    fileName: `${reportConfig.reportName}-${moment().format('YYYY-MM-DD')}.csv`,
    prependContent: header !== '' ? `${header}\n` : null,
    processCellCallback: exportProcessCellCallback,
  });
}

// Exports CSV to printable PDF
function exportPDF() {
  if (downloadPDFinProgress) {
    toastr.error('Wait', 'Download PDF request in process');
    return;
  } else {
    downloadPDFinProgress = true;
  }

  let gridCSV = gridOptions.api.getDataAsCsv();

  const el = document.getElementById('gridDiv');
  const verticalHeadersEnabled = el.classList.contains('ag-vertical-headers');

  // Headers are truncated at 8 chars when not using vertical headers
  if (!verticalHeadersEnabled) {
    const gridCSVpatch = gridCSV.split('\r\n');
    const headers = gridCSVpatch[0].split(',');
    headers.forEach((header, i) => {
      let headerText;

      // eslint-disable-next-line
      if ((headerText = header.match(/"(.*?)"/))) {
        headers[i] = `"${headerText[1].slice(0, 8)}"`;
      }
    });
    gridCSVpatch[0] = headers.join(',');
    gridCSV = gridCSVpatch.join('\r\n');
  }

  try {
    Api.post('/print/csv2pdf', {
      data: gridCSV,
      title: exportTitleHeader({ includeOptions: true, includeDate: true }),
      verticalHeaders: verticalHeadersEnabled,
    }).then(response => {
      downloadPDFinProgress = false;
      printJS({ printable: response.data.fileData, type: 'pdf', base64: true });
    });
  } catch (e) {
    console.error(e.message);
    downloadPDFinProgress = false;
  }
}

function exportTitleHeader({ includeOptions = false, includeDate = false, isCSV = false }) {
  // Look for an apropos report title to place at the top of the CSV export
  const candidate1 = _.get(reportConfig, 'config.page.Title', '');
  const candidate2 = _.get(reportConfig, 'config.page.Description', '');
  const exportStore = _.get(reportConfig, 'config.page.Report.exportstore', false);

  let header = candidate1 ? `${candidate1}` : candidate2 ? `${candidate2}` : '';

  if (includeDate) {
    header += ` - ${new Date().toLocaleString()}`;
  }

  // Prevents unnecessary parsing on ,
  if (isCSV) {
    header = `"${header}"`;
  }

  if (includeOptions) {
    const options = [];
    reportOptions.forEach(reportOption => {
      if (reportOption.type !== 'hidden' && reportOption.displayValue !== '') {
        options.push(`${reportOption.label}: ${reportOption.displayValue}`);
      }
    });

    if (options.length >= 1) {
      let optionsStr = options.join(' , ');
      if (isCSV) {
        optionsStr = `"${optionsStr}"`;
      }

      header += `\n${optionsStr}`;
    }

    // Reports commonly ran in multibranch mode probably wouldn't enable this option in the YAML
    // since store names would already appear in the branch column.  Nevertheless, support >=1 stores.
    if (exportStore) {
      const stores = [];
      if (multibranchAvailable) {
        // in this case, the multibranch selection control rendered - read selection
        const branchOptions = document.getElementById('multibranchSelection').options;
        for (let i = 0; i < branchOptions.length; i++) {
          if (branchOptions[i].selected) {
            stores.push(branchOptions[i].text);
          }
        }
      } else {
        // multibranch not available, display the active store only in this case
        stores.push(user.branch.name);
      }

      let storesStr = stores.join(' , ');
      if (isCSV) {
        storesStr = `"${storesStr}"`;
      }

      header += `\n${storesStr}`;
    }
  }

  return header;
}

// Generates a XLSX client side based on the current filters
// As of 7/2021, the legacy format support in ag-grid is broken, including in agg demos.
function exportXLS(useOldFormat = false) {
  const opts = getReportOptions();

  const beginningDate = _.get(
    _.find(opts, o => o.label === 'Beginning Date'),
    'value',
    ''
  );
  const endingDate = _.get(
    _.find(opts, o => o.label === 'Ending Date'),
    'value',
    ''
  );
  const startDate = _.get(
    _.find(opts, o => o.label === 'Start Date'),
    'value',
    ''
  );
  const endDate = _.get(
    _.find(opts, o => o.label === 'End Date'),
    'value',
    ''
  );

  const sheetName = (beginningDate || startDate) + (endingDate || endDate ? ` to ${endingDate || endDate}` : '');

  const title = exportTitleHeader({ includeDate: true, includeOptions: true });
  const prependContent = title.split('\n').map(str => {
    return [{ data: { value: str, type: 'String ' } }];
  });

  gridOptions.api.exportDataAsExcel({
    prependContent,
    exportMode: useOldFormat ? 'xml' : 'xlsx',
    fileName: `${reportConfig.reportName}-${moment().format('YYYY-MM-DD')}.${useOldFormat ? 'xls' : 'xlsx'}`,
    sheetName: sheetName || 'Sheet1', // override default "ag-grid" to default excel sheet name
    // shouldRowBeSkipped: params => {
    //   return params.node.rowPinned;
    // },
    processCellCallback: exportProcessCellXLSCallback,
  });
}

function fetchGeoCodes(zipcodes) {
  logTime('Fetch GeoCodes', 'start');

  const postBody = zipcodes;
  Api.post('report/geocodes', postBody)
    .then(res => {
      logTime('Fetch GeoCodes', 'stop');
      // Could check res.status and reject if needed
      geocodes = res.data;
    })
    .catch(() => {
      toastr.error('Error!', 'Network error.  Please try again later.');
    });
}

function fetchReportConfig(reportName) {
  return new Promise((resolve, reject) => {
    Api.get(`report/config/${reportName}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(() => {
        reject('fetch error');
      });
  });
}

// Executed when user events showResults()
// Utilizes the current reportConfig and reportOptions to determine what to fetch
function fetchReportData(bypassCache = false) {
  return new Promise((resolve, reject) => {
    /* Logically, we now do the following:
       1. Figure out which branch IDs to execute the report on
       2. For each branch, do an API post monkey patching the postBody with correct branch ID
       3. Only caclulate columnDefs on first pass (should be the same for all branches)
          - if report is multibranch, add branchID as first column in columnDef
       4. Add to dataLinesAggregate on each pass, prepending branch ID if multibranch report
       5. Parse the resulting dataLinesAggregate which should enable the report engine
          to see the branch ID as if were any other column from D3/QM.

       Note resolve/reject are for the enclosing promise for fetchReportData().
       The dynamically built promise chain for each API fetch uses subResolve/subReject per
       promise in the chain.
    */

    // determines which branch IDs to fetch report data for based on UI input
    const requestedBranches = (() => {
      const branchIDs = [];
      if (multibranchAvailable) {
        // in this case, the multibranch selection control rendered - read selection
        const branchOptions = document.getElementById('multibranchSelection').options;
        for (let i = 0; i < branchOptions.length; i++) {
          if (branchOptions[i].selected) {
            branchIDs.push({
              id: branchOptions[i].value,
              name: branchOptions[i].text,
            });
          }
        }
      } else {
        // multibranch not available
        // return the active branch ID only in this case
        // permission is inferred since the page loaded (passed react router security)
        branchIDs.push({
          id: user.branch.id,
          name: user.branch.name,
        });
      }
      return branchIDs;
    })();

    alternateBranchesRequested =
      requestedBranches.length > 1 || requestedBranches[0].id.toString() !== user.branch.id.toString();

    // this obj will be monkey patched on each iteration of the promise chain with branch ID
    const postBody = {
      reportOptions: _.map(reportOptions, 'value'), // "[]" if no options
      useCache: !bypassCache && document.getElementById('useCache').checked,
      skipLog: bypassCache, // bypassCache currently implies auto refresh, inform backend to skip logging
    };

    /* Dynamically build a promise chain of API service calls via returning
       promise factories.  Promise factories enable SEQUENTIAL data fetch (one D3 license at a time).

       The dynamically built chain enables proper error propogation.
       Any subReject in the chain will ultimately cause a reject() on fetchReportData.
       As of Dec 2016 we did not have async/await, which would make this code simpler to read.
    */

    let pChain = Promise.resolve(); // start the chain
    dataLinesAggregate = [];

    requestedBranches.forEach(branch => {
      pChain = pChain.then(() => {
        return new Promise((subResolve, subReject) => {
          // branch.id, branch.name, subResolve, subReject
          postBody.branchID = branch.id;
          waitingBranch.innerHTML = `${branch.name}`;

          logTime(`Fetch Report Data: ${branch.name}`, 'start');

          /* The API service returns a promise which we need to emulate cancel-ability upon.
             If the user navigates away from the report or otherwise unmounts this instantiation of
             the report component, the .then() callback (or .catch in the case of an error) below
             would STILL fire.  This could manifest itself in strange ways, for example, if the user hit
             a long running report like PSR2, but navigated away to SMF6 before receiving results,
             moments later, the SMF6 grid would populate erroneously with PSR2 data.  Bad.

             Redux handles this by subscribing/unsubscribing to an event emitter
             which logically does the same thing we do here.  Since the report runner is 95% VanillaJS,
             we can achieve the same result ourselves with a simple ES6 map and closures.
          */

          const promiseID = uuidv4();

          // track this pending promise for external "cancellation"
          promiseIDs.set(promiseID, true);

          Api.post(`report/data/${reportConfig.reportName}`, postBody)
            .then(res => {
              // has the user navigated away?  if so, the promise was "cancelled", terminate the chain
              if (!promiseIDs.has(promiseID)) {
                return;
              }

              logTime(`Fetch Report Data: ${branch.name}`, 'stop');
              // Could check res.status and reject if needed
              if (res.data.length < 9 && (res.data === 'no data' || ~res.data.indexOf('NO.DATA'))) {
                // no data received / no lines added to cumulative dataLines - advance chain
                subResolve();
              } else {
                const dataLines = res.data.split('\n'); // perf seems ok even on huge data sets + crappy mobile

                // some dynamic reports have a bug wherein the headers are still sent even if there are
                // no data rows to show. this hotfix is easier than Ben having to fix/track on his side.
                if (dynamicReport && dataLines.length === 2 && dataLines[1] === '') {
                  subResolve();
                  return;
                }

                // only need to cacluate columnDefs once
                try {
                  if (!columnDefs) {
                    columnDefs = dynamicReport
                      ? getColumnDefs(dataLines[0], false)
                      : getColumnDefs(null, alternateBranchesRequested);
                  }
                } catch (e) {
                  subReject('config error');
                  return;
                }

                // inject branch where appropriate
                if (!dynamicReport && alternateBranchesRequested) {
                  const totalLines = dataLines.length;
                  for (let i = 0; i < totalLines; i++) {
                    if (!!dataLines[i]) {
                      dataLines[i] += `ý${branch.name}ý${branch.id}`;
                    }
                  }
                }

                dataLinesAggregate = dataLinesAggregate.concat(dataLines);
                subResolve(); // per API fetch success
              }
            })
            .catch(() => {
              // has the user navigated away?  if so, the promise was "cancelled", terminate the chain
              if (!promiseIDs.has(promiseID)) {
                return;
              }
              subReject(); // per API fetch error
            });
        });
      });
    });

    // upon full promise chain completion
    pChain
      .then(() => {
        // resolve fetchReportData promise when all API calls complete
        if (dataLinesAggregate.length === 0) {
          resolve('NO DATA');
        } else {
          waitingBranch.innerHTML = 'Parsing Data';
          setTimeout(() => {
            logTime('Parse Report Data', 'start');

            // this is async to the promise chain, thus try/catch
            try {
              parseDataLines(dataLinesAggregate); // branch IDs already injected where appropriate
            } catch (e) {
              reject('parse error');
              return;
            }

            logTime('Parse Report Data', 'stop');
            waitingBranch.innerHTML = '';
            resolve();
          }, 25); // 25ms delay so "Parsing Data" will show pre-parse
        }
      })
      .catch(e => {
        if (e === 'config error') {
          reject('config error');
        } else {
          reject('fetch error'); // reject fetchReportData promise upon any other subReject
        }
      });
  });
}

// Attempts to squeeze all columns into visible view port
function fitAllColumns() {
  gridOptions.api.sizeColumnsToFit();
}

/* Reads column headers from reportConfig property in this module,
   which is initialized when fetchReportConfig() executes. Reference the
   ag-grid docs for a description of columnDefs.

   The ugliness is attirbuted to the format of the current YAML configs.
   The code checks for malformed YAMLs and missing configuration in order
   to be resilient (Databridge currently hangs on column mismatches).

   Supports both statically defined columns (from YAML), as well as dynamically
   defined columns (from D3/QM in first returned data row)
*/
function getColumnDefs(dynamicDefs = null, injectBranchID = false) {
  const newColumnDefs = [];
  const pathToCols = `config.translations[${reportConfig.reportName}].cols`;
  const cols = _.get(reportConfig, pathToCols, []);

  if (dynamicReport) {
    // dynamic columns report
    // extract the column names & order in whch they should appear on the dynamic report
    // this comes from the first row of data returned from D3/QM
    const dynamicCols = dynamicDefs.split('ý');

    // extract defaults from name: "*" column definition
    const defaultsCol = _.find(cols, o => _.has(o, 'name') && o.name === '*');
    const defaultType = _.get(defaultsCol, 'type', 'string');

    // optionally specified double precision - only applied on double types
    let defaultPrecision = parseInt(_.get(defaultsCol, 'options.precision', '2'), 10); // default 2
    if (isNaN(defaultPrecision) || defaultPrecision < 0) {
      defaultPrecision = 2;
    }

    // dynamic reports
    dynamicCols.forEach((col, i) => {
      // extract any static column overrides for this column in the YAML
      const yamlColDef = _.find(cols, o => (_.has(o, 'en') && o.en === col) || (_.has(o, 'name') && o.name === col)); // undefined if not specified

      /* Default ag-grid "field" name and "headerName" to what's dynamically specified from D3/QM
         (in the first row of data returned), but allow override in the YAML.  As long as 1 of
         these fields matches what comes down the data wire, the other field can be overridden.
         This is useful when using modals that require compound lookup keys (such as expecting
         "dvs" to be the field name, but "Division" comes down the header wire (PCR4 issue 3/3/20)).
      */
      const field = _.get(yamlColDef, 'name', col);
      const headerName = _.get(yamlColDef, 'en', col);

      /* Detect if this field has already been defined.  Field names must be unique since data
         is added to the grid in field:value pairs per the ag-grid API.  We hit this issue on a
         dynamic report which tried to redefine field '%' several times.  This will at least give
         the programmer a helpful hint on his/her error.
      */

      if (_.findIndex(newColumnDefs, o => o.field === field) !== -1) {
        console.error(`Field: '${field}' defined more than once.  Column field names MUST be unique.`);
      }

      // not currently used in YAML for dynamic reports - implement in future if necessary
      let suppressAverageAggregation = _.has(yamlColDef, 'aggs.average') && yamlColDef.aggs.average === null;
      let suppressSubtotalAggregation = _.has(yamlColDef, 'aggs.subtotals') && yamlColDef.aggs.subtotals === null;
      let suppressTotalAggregation = _.has(yamlColDef, 'aggs.totals') && yamlColDef.aggs.totals === null;

      // turn off all aggregations for any dynamic column ending with '%'
      if (!yamlColDef && col.endsWith('%')) {
        suppressAverageAggregation = true;
        suppressSubtotalAggregation = true;
        suppressTotalAggregation = true;
      }

      // optionally override width for any column, default to 175
      let width = _.get(yamlColDef, 'width', 175);

      // if this column falls under * default definition, apply any width attached to the default
      if (!yamlColDef) {
        width = _.get(defaultsCol, 'width', 175);
      }

      // optionally hide a column (still available in row node for calculations)
      const hide = _.get(yamlColDef, 'hidden', false);

      // optionally move a column after render (without changing D3/QM output) - occurs in showResults()
      const moveto = _.get(yamlColDef, 'moveto', null);

      // optionally show tooltip on hover (reveal contents of cell easier)
      const tooltipField = _.get(yamlColDef, 'tooltip', false) === true ? field : null;

      // look for statically defined type, otherwise apply default type found above
      const valueType = _.get(yamlColDef, 'type', defaultType);

      // look for statitically defined precision, otherwise apply default precision found above
      let precision = parseInt(_.get(yamlColDef, 'options.precision', defaultPrecision), 10); // default 2
      if (isNaN(precision) || precision < 0) {
        precision = 2;
      }

      let comparator = null;
      if (valueType === 'currency' || valueType === 'double') {
        comparator = (valueA, valueB) => {
          valueA = valueA !== '' ? valueA : '0';
          valueB = valueB !== '' ? valueB : '0';
          return parseFloat(valueA) - parseFloat(valueB);
        };
      }

      let cellRenderer, cellRendererSelector, valueFormatter;

      // adds $ before currency content during render while keeping the underlying value a number,
      // which maintains the ability to aggregate on currencies
      if (valueType === 'currency') {
        valueFormatter = currencyValueFormatter;
      }

      // Observes options.precision on the coldef
      if (valueType === 'double') {
        valueFormatter = doubleValueFormatter;
      }

      // individual column cellRenderer overrides (currently unused by any dynamic report)
      if (_.has(renderHooks, `${reportConfig.reportName}.${field}`)) {
        cellRenderer = renderHooks[reportConfig.reportName][field];
      }

      // sparkline support specifies sparklineOptions in the widget files
      if (valueType === 'sparkline') {
        sparklinePresent = true;

        // just in case a renderHook is erroneously specified in widget file
        cellRenderer = undefined;

        let sparklineRendererParams = {};
        if (_.has(sparklineOptions, `${reportConfig.reportName}.${field}`)) {
          sparklineRendererParams = {
            sparklineOptions: sparklineOptions[reportConfig.reportName][field],
          };
        }

        cellRendererSelector = function (params) {
          // Don't render a sparkline on a pinned or group row (prevents exception)
          if (params.node.rowPinned || params.node.group) {
            return undefined;
          } else {
            return {
              component: 'agSparklineCellRenderer',
              params: {
                ...sparklineRendererParams,
              },
            };
          }
        };
      }

      // check for style hooks to conditionally apply to rows depending on the value
      // see WEBPI4 for global hooks, WEBAR2A for per column hooks
      // global hooks are more apropos for dynamic reports
      let cellClassRules = null;

      // global cellClassRules hook if available
      if (_.has(styleHooks, `${reportConfig.reportName}.globalStyleHook`)) {
        cellClassRules = styleHooks[reportConfig.reportName].globalStyleHook(field);
      }

      // individual column cellClassRules overrides
      if (_.has(styleHooks, `${reportConfig.reportName}.${field}`)) {
        cellClassRules = styleHooks[reportConfig.reportName][field];
      }

      // cellStyle gets applied to ALL cells in the column regardless of the cell value
      const cellStyle = {};

      // always apply right-align on numbers - makes accounting professionals happy
      if (_.includes(['currency', 'double', 'integer'], valueType)) {
        cellStyle['text-align'] = 'right';
        cellStyle['padding-right'] = '10px';
      }

      // check for any CSS rules defined in the YAML and apply to cellStyle here
      if (_.has(yamlColDef, 'css')) {
        const rules = _.get(yamlColDef, 'css');
        for (const rule of Object.keys(rules)) {
          cellStyle[rule] = rules[rule];
        }
      } else if (_.has(defaultsCol, 'css')) {
        const rules = _.get(defaultsCol, 'css');
        for (const rule of Object.keys(rules)) {
          cellStyle[rule] = rules[rule];
        }
      }

      // cellClass is used for .xls support
      let cellClass = null;
      switch (valueType) {
        case 'currency':
          cellClass = 'xls-currency';
          break;
        case 'double':
          cellClass = precision === 4 ? 'xls-doubleFourPlaces' : 'xls-doubleTwoPlaces';
          break;
        case 'integer':
          cellClass = 'xls-integer';
          break;
        case 'string':
        default:
          cellClass = 'xls-string';
          break;
      }

      // helper modals - ben states only 1 modal set per column
      let helpers = _.get(yamlColDef, 'helpers', '');
      if (helpers) {
        helpers = Object.keys(helpers)[0];
      }

      // custom dynamic helpers for WEBPI4
      if (
        reportConfig.reportName === 'WEBPI4' &&
        !_.includes(['Cust #', 'Customer', 'Total', 'GP %', 'branch'], field)
      ) {
        helpers = 'WEBPI4';
      }

      // custom dynamic helpers for PMR4
      if (
        _.includes(['PMR4', 'SSR9'], reportConfig.reportName) &&
        !_.includes(
          [
            'slsman',
            'cusno',
            'cusnam',
            'county',
            'addr',
            'cty',
            'statee',
            'zipcode',
            'phn',
            'cntact',
            'eml',
            'pricecode',
            'rpttot',
          ],
          field
        )
      ) {
        helpers = 'PMR4SSR9';
      }

      // custom dynamic helpers for PMR4A
      if (
        _.includes(['PMR4A'], reportConfig.reportName) &&
        !_.includes(
          [
            'slsman',
            'cusno',
            'cusnam',
            'county',
            'addr',
            'cty',
            'statee',
            'zipcode',
            'phn',
            'cntact',
            'eml',
            'pricecode',
            'rpttot',
          ],
          field
        )
      ) {
        helpers = 'PMR4A';
      }

      // custom dynamic helpers for PPO15
      if (
        _.includes(['PPO15'], reportConfig.reportName) &&
        !_.includes(['Vendor', 'Name', 'Total', 'Details'], field)
      ) {
        helpers = 'PPO15';
      }

      // custom dynamic helpers for PSH1A/PSH1B
      if (
        _.includes(['PSH1A', 'PSH1B'], reportConfig.reportName) &&
        !_.includes(['stock_class', 'stock_class_name', 'Total'], field) &&
        !/GP %$/.test(field)
      ) {
        helpers = 'PSH1B';
      }

      let filter;
      let filterParams;

      if (_.includes(['currency', 'double', 'integer'], valueType)) {
        filter = 'agNumberColumnFilter';
        filterParams = { buttons: ['clear'] };
      } else if (valueType === 'date') {
        filter = 'agDateColumnFilter';
        filterParams = { buttons: ['clear'] };
        filterParams.comparator = DateComparator;
        filterParams.inRangeInclusive = true;
      } else if (valueType === 'sparkline') {
        filter = undefined;
      } else {
        filter = 'agMultiColumnFilter';
        filterParams = {
          filters: [
            {
              filter: 'agTextColumnFilter',
              filterParams: {
                buttons: ['clear'],
              },
            },
            {
              filter: 'agSetColumnFilter',
              filterParams: {
                buttons: ['reset'],
              },
            },
          ],
        };
      }

      // setup grouped aggFunc - Ben wants summations only for now, this can be expanded later via YAML
      // see: https://www.ag-grid.com/javascript-grid-aggregation/#gsc.tab=0
      let aggFuncToApply = null;
      if (_.has(reportConfig.config, 'page.Report.aggs')) {
        if (_.includes(reportConfig.config.page.Report.aggs, 'totals') && !suppressTotalAggregation) {
          switch (valueType) {
            case 'currency':
              aggFuncToApply = 'groupAggFuncCurrency';
              break;
            case 'double':
              aggFuncToApply = 'groupAggFuncDouble';
              break;
            case 'integer':
              aggFuncToApply = 'sum'; // use built-in summation for now
              break;
            default:
              break;
          }
        }
      }

      newColumnDefs[i] = {
        aggFuncToApply,
        cellClass,
        cellClassRules,
        cellRenderer,
        cellRendererSelector,
        cellStyle,
        comparator,
        enableRowGroup: valueType !== 'sparkline',
        enableValue: true,
        field,
        filter,
        filterParams,
        headerComponentParams: {
          template:
            `<div class="ag-cell-label-container" role="presentation" title="${headerName}">` +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            `${helpers ? '<i class="fas fa-th-list"></i> &nbsp;' : ''}` +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span> &nbsp;' +
            '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
            '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
            '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
            '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
            '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>',
        },
        headerName,
        helpers,
        hide,
        moveto,
        precision,
        suppressAverageAggregation,
        suppressSubtotalAggregation,
        suppressTotalAggregation,
        tooltipField,
        valueFormatter,
        valueType,
        width, // ag-grid uses 200px if not set here
      };

      if (rangecharts) {
        switch (valueType) {
          case 'currency':
          case 'double':
          case 'integer':
            newColumnDefs[i].chartDataType = 'series';
            break;
          case 'string':
          default:
            newColumnDefs[i].chartDataType = 'category';
            break;
        }
      }
    });
  } else {
    // static columns report

    let index;

    cols.forEach((col, i) => {
      // only add a column if a valid, numeric index is defined in the YAML (static case)
      index = _.get(col, 'index', '');
      if (_.isNumber(index)) {
        // if column name info missing, use UNDEF1, UNDEF2, etc.
        const headerName = _.get(col, 'en', `UNDEF${i}`);
        const field = _.get(col, 'name', `UNDEF${i}`);
        const valueType = _.get(col, 'type', 'string'); // integer, double, currency, string

        if (_.get(col, 'itemid')) {
          itemId = field;
        }

        /* Detect if this field has already been defined.  Field names must be unique since data
           is added to the grid in field:value pairs per the ag-grid API.  We hit this issue on a
           dynamic report which tried to redefine field '%' several times.  This will at least give
           the programmer a helpful hint on his/her error.  In this case, the YAML author statically
           defined the same field twice.
        */

        if (_.findIndex(newColumnDefs, o => o.field === field) !== -1) {
          console.error(`Field: '${field}' defined more than once.  Column field names MUST be unique.`);
        }

        // optionally specified double precision - only applied on double types
        let precision = parseInt(_.get(col, 'options.precision', '2'), 10); // default 2
        if (isNaN(precision) || precision < 0) {
          precision = 2;
        }

        const suppressAverageAggregation = _.has(col, 'aggs.average') && col.aggs.average === null;
        const suppressSubtotalAggregation = _.has(col, 'aggs.subtotals') && col.aggs.subtotals === null;
        const suppressTotalAggregation = _.has(col, 'aggs.totals') && col.aggs.totals === null;

        // optionally override width for any column, default to 175
        const width = _.get(col, 'width', 175);

        // optionally hide a column (still available in row node for calculations)
        const hide = _.get(col, 'hidden', false);

        // optionally move a column after render (without changing D3/QM output) - occurs in showResults()
        const moveto = _.get(col, 'moveto', null);

        // optionally show tooltip on hover (reveal contents of cell easier)
        let tooltipField = _.get(col, 'tooltip', false) === true ? field : null;

        let comparator = null;
        if (valueType === 'currency' || valueType === 'double') {
          comparator = (valueA, valueB) => {
            valueA = valueA !== '' ? valueA : '0';
            valueB = valueB !== '' ? valueB : '0';
            return parseFloat(valueA) - parseFloat(valueB);
          };
        }

        if (_.get(col, 'smartsort', false) === true) {
          comparator = SmartSortComparator;
        }

        let cellRenderer, cellRendererSelector, valueFormatter, getQuickFilterText;

        // adds $ before currency content during render while keeping the underlying value a number,
        // which maintains the ability to aggregate on currencies
        if (valueType === 'currency') {
          valueFormatter = currencyValueFormatter;
        }

        // Observes options.precision on the coldef
        if (valueType === 'double') {
          valueFormatter = doubleValueFormatter;
        }

        // individual column cellRenderer overrides
        if (_.has(renderHooks, `${reportConfig.reportName}.${field}`)) {
          cellRenderer = renderHooks[reportConfig.reportName][field];
        }

        // sparkline support specifies sparklineOptions in the widget files
        if (valueType === 'sparkline') {
          sparklinePresent = true;

          // just in case a renderHook is erroneously specified in widget file
          cellRenderer = undefined;

          let sparklineRendererParams = {};
          if (_.has(sparklineOptions, `${reportConfig.reportName}.${field}`)) {
            sparklineRendererParams = {
              sparklineOptions: sparklineOptions[reportConfig.reportName][field],
            };
          }

          cellRendererSelector = function (params) {
            // Don't render a sparkline on a pinned or group row (prevents exception)
            if (params.node.rowPinned || params.node.group) {
              return undefined;
            } else {
              return {
                component: 'agSparklineCellRenderer',
                params: {
                  ...sparklineRendererParams,
                },
              };
            }
          };
        }

        // check for style hooks to conditionally apply to rows depending on the value
        // see WEBPI4 for global hooks, WEBAR2A for per column hooks
        // global hooks are more apropos for dynamic reports
        let cellClassRules = {};

        // global cellClassRules hook if available
        if (_.has(styleHooks, `${reportConfig.reportName}.globalStyleHook`)) {
          cellClassRules = styleHooks[reportConfig.reportName].globalStyleHook(field);
        }

        // individual column cellClassRules overrides
        if (_.has(styleHooks, `${reportConfig.reportName}.${field}`)) {
          cellClassRules = styleHooks[reportConfig.reportName][field];
        }

        // cellStyle gets applied to ALL cells in the column regardless of the cell value
        let cellStyle = {};

        // always apply right-align on numbers - makes accounting professionals happy
        if (_.includes(['currency', 'double', 'integer'], valueType)) {
          cellStyle['text-align'] = 'right';
          cellStyle['padding-right'] = '10px';
        }

        // check for any CSS rules defined in the YAML and apply to cellStyle here
        if (_.has(col, 'css')) {
          const rules = _.get(col, 'css');
          for (const rule of Object.keys(rules)) {
            cellStyle[rule] = rules[rule];
          }
        }

        // cellClass is used for .xls support
        let cellClass = null;
        switch (valueType) {
          case 'currency':
            cellClass = 'xls-currency';
            break;
          case 'double':
            cellClass = precision === 4 ? 'xls-doubleFourPlaces' : 'xls-doubleTwoPlaces';
            break;
          case 'integer':
            cellClass = 'xls-integer';
            break;
          case 'string':
          default:
            cellClass = 'xls-string';
            break;
        }

        // helper modals - ben states only 1 modal set per column
        let helpers = _.get(col, 'helpers', '');
        if (helpers) {
          helpers = Object.keys(helpers)[0];
        }

        let filter;
        let filterParams;

        if (_.includes(['currency', 'double', 'integer'], valueType)) {
          filter = 'agNumberColumnFilter';
          filterParams = { buttons: ['clear'] };
        } else if (valueType === 'date') {
          filter = 'agDateColumnFilter';
          filterParams = { buttons: ['clear'] };
          filterParams.comparator = DateComparator;
          filterParams.inRangeInclusive = true;
        } else if (valueType === 'sparkline') {
          filter = undefined;
        } else {
          filter = 'agMultiColumnFilter';
          filterParams = {
            filters: [
              {
                filter: 'agTextColumnFilter',
                filterParams: {
                  buttons: ['clear'],
                },
              },
              {
                filter: 'agSetColumnFilter',
                filterParams: {
                  buttons: ['reset'],
                },
              },
            ],
          };
        }

        // setup grouped aggFunc - Ben wants summations only for now, this can be expanded later via YAML
        // see: https://www.ag-grid.com/javascript-grid-aggregation/#gsc.tab=0
        let aggFuncToApply = null;
        if (_.has(reportConfig.config, 'page.Report.aggs')) {
          if (_.includes(reportConfig.config.page.Report.aggs, 'totals') && !suppressTotalAggregation) {
            switch (valueType) {
              case 'currency':
                aggFuncToApply = 'groupAggFuncCurrency';
                break;
              case 'double':
                aggFuncToApply = 'groupAggFuncDouble';
                break;
              case 'integer':
                aggFuncToApply = 'sum'; // use built-in summation for now
                break;
              default:
                break;
            }
          }
        }

        // Shop Status (WEBRO2) specific features (Editable promise by date and Status color columns)
        let editable = false;
        let onCellValueChanged = null;
        let tooltipValueGetter = null; // currently only used by WEBRO2 for custom tooltip renders

        if (roReports.includes(reportConfig.reportName)) {
          switch (field) {
            case 'location':
              editable = true;
              onCellValueChanged = shopStatusLocationEdit;
              cellStyle = statusCodeCellStyle;
              filterParams.filters[1].filterParams.valueFormatter = statusCodeValueFormatter;
              valueFormatter = statusCodeValueFormatter;
              getQuickFilterText = statusCodeValueFormatter;
              break;
            case 'nextTech':
              // provide a custom tooltip callback here
              tooltipField = null;
              tooltipValueGetter = ({ value }) => {
                // Cross reference the ID against the mechanics list, show name if found
                if (reportConfig.activeTechs) {
                  const tech = _.find(reportConfig.activeTechs, { techNo: value });
                  if (tech) {
                    return tech.techName || value; // revert to cell value if techName not specified
                  }
                }
                // Not found, tooltip remains the cell value
                return value;
              };
              break;
            case 'promiseDate':
              editable = true;
              onCellValueChanged = shopStatusPromisedEdit;
              break;
            case 'status':
              cellStyle = statusCodeCellStyle;
              valueFormatter = statusCodeValueFormatter;

              // Value Formatter for the Set Filter values
              filterParams.filters[1].filterParams.valueFormatter = statusCodeValueFormatter;
              comparator = StatusCodeComparator;
              getQuickFilterText = statusCodeValueFormatter;
              break;
            default:
              break;
          }
        }

        if (reportConfig.reportName === 'SML9') {
          switch (field) {
            case 'From':
            case 'After':
              cellStyle = statusCodeCellStyle;
              valueFormatter = statusCodeValueFormatter;
              filterParams.filters[1].filterParams.valueFormatter = statusCodeValueFormatter;
              comparator = StatusCodeComparator;
              getQuickFilterText = statusCodeValueFormatter;
              break;
            default:
          }
        }

        newColumnDefs[index] = {
          aggFuncToApply,
          cellClass,
          cellClassRules,
          cellRenderer,
          cellRendererSelector,
          cellStyle,
          comparator,
          editable,
          enableRowGroup: valueType !== 'sparkline',
          enableValue: true,
          field,
          filter,
          filterParams,
          getQuickFilterText,
          headerComponentParams: {
            template:
              `<div class="ag-cell-label-container" role="presentation" title="${headerName}">` +
              '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
              '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
              `${col.helpers ? '<i class="fas fa-th-list"></i> &nbsp;' : ''}` +
              '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span> &nbsp;' +
              '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
              '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
              '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
              '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
              '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
              '  </div>' +
              '</div>',
          },
          headerName,
          helpers,
          hide,
          onCellValueChanged,
          moveto,
          precision,
          suppressAverageAggregation,
          suppressSubtotalAggregation,
          suppressTotalAggregation,
          tooltipField, // overrides tooltip
          tooltipValueGetter,
          valueType,
          valueFormatter,
          width, // ag-grid uses 200px if not set here
        };

        if (rangecharts) {
          switch (valueType) {
            case 'currency':
            case 'double':
              newColumnDefs[index].chartDataType = 'series';
              break;
            case 'integer': // often times a salesman number, etc.
              newColumnDefs[index].chartDataType = _.get(col, 'rangecategory', false) ? 'category' : 'series';
              break;
            case 'string':
            default:
              newColumnDefs[index].chartDataType = 'category';
              break;
          }
        }
      }
    });

    // so as to not throw off the YAML specified column indexes, we'll inject branch ID as a
    // trailing column when appropriate, then use the moveto feature to put it at position 0
    // (left most column), which will occur after all other columns have been moved
    if (injectBranchID) {
      const injectIndex = Number(index) + 1;
      newColumnDefs[injectIndex] = {
        enableRowGroup: true,
        enableValue: true,
        field: 'bzBranchName', // "blaze" branch name - unique to not stomp on possible YAML def
        filter: 'set',
        headerName: 'Branch',
        moveto: '0',
        valueType: 'string',
        width: 80,
      };

      // hidden branch ID field used by drilldowns on multibranch reports
      newColumnDefs[injectIndex + 1] = {
        enableRowGroup: true,
        enableValue: true,
        field: 'bzBranchID',
        filter: 'set',
        headerName: 'Branch ID',
        hide: true,
        moveto: null,
        valueType: 'string',
        width: 80,
      };
    }

    if (autoRefreshSecs) {
      // DSI's "CustomAnimationRenderer" found in utils/grid.js depends on this hidden field for
      // tracking timestamps of data updates.  The result is an object keyed on column field names.
      newColumnDefs.push({
        field: 'updateHistory',
        hide: true,
      });
    }
  }

  return newColumnDefs;
}

// ag-grid hook to add new menu items on column headers.
// Currently utilized to add "Aggregate Column" feature for full column range selection.
function getMainMenuItems(params) {
  if (_.get(params, 'column.colDef.valueType', '') === 'sparkline') {
    return params.defaultItems;
  }

  const modifiedMenu = params.defaultItems.slice(0);

  modifiedMenu.push({
    name: 'Aggregate Column',
    action() {
      gridOptions.api.clearRangeSelection();
      gridOptions.api.addCellRange({
        rowStartIndex: 0,
        rowEndIndex: rowCount - 1,
        columnStart: params.column.getId(),
        columnEnd: params.column.getId(),
      });
    },
  });

  return modifiedMenu;
}

function getOptionsForLayoutHash() {
  return _.map(
    _.filter(reportOptions, o => !o.skiplayouthash),
    'value'
  );
}

function getPPC() {
  return user.ppc;
}

// ag-grid calls this per row only as needed (only for visible/buffered rows, not all data rows at once)
function getRowHeight(params) {
  // default is 25px in ag-grid
  let rowHeight = 25;

  // two special cases
  if (reportConfig.reportName === 'WEBAR4') {
    if (!params.node.group && !params.node.rowPinned) {
      // look to params.data.notes to dynamically determine row height
      // see https://ag-grid.com/javascript-grid-row-height/index.php
      // remove trailing <br>s first
      const lines = (params.data.notes.replace(/(<br>\s*)+$/, '').match(/<br>/g) || []).length + 1;
      rowHeight = lines * 30 - (lines - 1) * 5; // 30px per line - a little padding buildup
    }
  } else if (reportConfig.reportName === 'SCR6') {
    if (!params.node.group && !params.node.rowPinned) {
      const comptxtLines =
        (wordwrap(params.data.comptxt, { indent: '', width: 55, newline: '<br>' }).match(/<br>/g) || []).length + 1;
      const corrtxtLines =
        (wordwrap(params.data.corrtxt, { indent: '', width: 55, newline: '<br>' }).match(/<br>/g) || []).length + 1;
      const lines = Math.max(comptxtLines, corrtxtLines);
      rowHeight = lines * 30 - (lines - 1) * 5; // 30x per line - a little padding buildup
    }
  } else {
    if (!params.node.group && !params.node.rowPinned) {
      /* Does this report have at least 1 column defined with a sparkline?
         In this instance, we infer rowHeightOverride to be applied only when sparklines are visible.
      */
      if (sparklinePresent) {
        const sparklineVisible = gridOptions.columnApi
          .getAllDisplayedColumns()
          .some(o => o.colDef.valueType === 'sparkline');

        // If at least one sparkline is visible, apply rowHeightOverride (if defined), or 100px.
        // Otherwise leave default row height of 25px.
        if (sparklineVisible) {
          rowHeight = rowHeightOverride || 100;
        }

        // If no sparklines are defined in this report, but the user specifically used rowHeightOverride, always apply it.
      } else if (rowHeightOverride) {
        rowHeight = rowHeightOverride;
      }
    }
  }
  return rowHeight;
}

function getRowStyle(params) {
  if (params.node.rowPinned) {
    // style the footer rows
    if (_.includes(params.data, 'Filtered Average')) {
      return {
        'font-weight': 'bold',
        color: 'white',
        'background-color': '#31B0D5',
        border: '1px double white',
      };
    }
    if (_.includes(params.data, 'Average')) {
      return {
        'font-weight': 'bold',
        color: 'white',
        'background-color': '#4f7192',
        border: '1px double white',
      };
    }
    if (_.includes(params.data, 'Filtered Total')) {
      return {
        'font-weight': 'bold',
        color: 'white',
        'background-color': '#31B0D5',
        border: '1px double white',
      };
    }
    if (_.includes(params.data, 'Total')) {
      return {
        'font-weight': 'bold',
        color: 'white',
        'background-color': '#2B3E50',
        border: '1px double white',
      };
    }
  }
  return undefined;
}

// WEBRO2 widgets need this information for dynamic coloring
function getShopStatusCodes() {
  return store.getState().app.codes;
}

function getReportOptions() {
  return reportOptions;
}

function groupAggFuncCurrency(params) {
  const { values } = params;

  let sum = 0.0;
  for (let i = 0; i < values.length; i++) {
    // It's possible some rows have empty data.
    const doubleValue = parseFloat(values[i]);
    if (!isNaN(doubleValue)) {
      sum += doubleValue;
    }
  }
  return sum.toFixed(2);
}

function groupAggFuncDouble(params) {
  const { values } = params;
  const precision = _.get(params, 'colDef.precision', 2);
  let sum = 0.0;

  for (let i = 0; i < values.length; i++) {
    // It's possible some rows have empty data.
    const doubleValue = parseFloat(values[i]);
    if (!isNaN(doubleValue)) {
      sum += doubleValue;
    }
  }

  return sum.toFixed(precision);
}

// Generates a SHA1 hash of user supplied report option values,
// skipping any option with skiplayouthash: true
function hashOptions() {
  return hash(getOptionsForLayoutHash());
}

function isAlternateBranchesRequested() {
  return alternateBranchesRequested;
}

function loadLayoutDialog() {
  modal.open({
    title: 'Load Layout',
    message: (
      <>
        {dynamicReport && (
          <Alert variant="warning">
            Since this is a dynamic report, different data columns may be shown based on the report options selected
            when running the report. Any layouts previously saved for this report will only appear available to be
            loaded if the dynamic report was ran with the same options used when saving the layout you wish to load.
            Note some options such as To/From dates are not considered when pairing saved layouts to the dynamic report
            options.
          </Alert>
        )}
        <LoadGridLayoutForm
          currentLayoutId={_.get(reportConfig.userSettings.layout, 'id')}
          pageName={reportConfig.reportName}
          optionsHash={dynamicReport ? hashOptions() : null}
          onCancel={() => modal.close()}
          onSubmit={gridLayout => {
            loadLayoutInner(gridLayout);
            modal.close();
          }}
        />
      </>
    ),
    hidePrint: true,
    headerClass: 'primary',
    hideFooter: true,
  });
}

/**
 * Sets active layout and applies to ag-grid
 * @param {GridLayout} layoutObj
 */
function loadLayoutInner(layoutObj) {
  setActiveLayout(layoutObj);

  if (!layoutObj) {
    return;
  }

  const { layout } = layoutObj;

  // Transpose pre-multifilter text/set saves
  for (const field of Object.keys(layout.f)) {
    const filterType = layout.f[field].filterType;
    if (['set', 'text'].includes(filterType)) {
      const columnDef = _.find(columnDefs, o => o.field === field);

      // We're only supporting set filters on string columns from now on.
      // It's possible, but probably unlikely, someone saved a set filter on a non-string column.
      if (columnDef && columnDef.valueType !== 'string') {
        delete layout.f[field];
      } else {
        // Transpose the set/text filter to the multifilter model we use in v26+.
        layout.f[field] = {
          filterType: 'multi',
          filterModels: [filterType === 'text' ? layout.f[field] : null, filterType === 'set' ? layout.f[field] : null],
        };
      }
    }
  }

  // layout.c includes sort model info which was previously separate in earlier versions of ag-grid.
  gridOptions.columnApi.applyColumnState({ state: layout.c, applyOrder: true });

  // Just in case a layout with sort was saved before getColumnState included it, apply the partial state.
  // These cases should dwindle to 0 eventually as new layouts are saved which do not use layout.s.
  if (layout.s) {
    gridOptions.columnApi.applyColumnState({ state: layout.s });
  }

  // The filter model is saved separately from the column state.
  gridOptions.api.setFilterModel(layout.f);

  // This supports saving a header orientation that deviates from the YAML spec.
  if (
    (verticalHeadersDefault && _.get(layout.c, '0.blazeForceHorizontalHeader', false)) ||
    (!verticalHeadersDefault && _.get(layout.c, '0.blazeForceVerticalHeader', false))
  ) {
    toggleVerticalHeaders();
  }
}

// Runs after each data fetch.
function loadLayout() {
  if (dynamicReport) {
    // Load the last used layout for this specific dynamic report hash, if available.
    Api.get('user-grid-layouts', { params: { pageName: reportConfig.reportName, optionsHash: hashOptions() } })
      .then(response => {
        if (response.data && response.data.length && response.data[0].GridLayout) {
          const layout = response.data[0].GridLayout;
          reportConfig.userSettings.layout = layout;
          loadLayoutInner(layout);
        } else {
          loadLayoutInner(null);
        }
      })
      .catch(console.error);

    // Otherwise (static report), we obtained the last applied layout in the same call we obtained the initial report config.
    // It's possible the user selected an alternative layout in the report options.  Apply if so.
  } else {
    const layoutOptionId = document.getElementById('optionLayoutId');
    if (layoutOptionId) {
      if (layoutOptionId.value === 'default') {
        loadLayoutInner(null);
      } else {
        const { myLayoutOptions, publicLayoutOptions } = reportConfig.userSettings;
        const layout =
          _.find([...myLayoutOptions, ...publicLayoutOptions], { id: Number(layoutOptionId.value) }) || null;
        loadLayoutInner(layout);
      }

      // Some reports never display report options and the layout is only changed via the LoadLayout control.
    } else {
      loadLayoutInner(_.get(reportConfig.userSettings, 'layout', null));
    }
  }
}

// Enable diagnostic timing by setting reportperf=1 in dev console.
// Useful in dev to see how long fetches / parses take.
function logTime(logevent, status = 'stop') {
  if (typeof reportperf !== 'undefined' && reportperf) {
    if (status === 'start') {
      console.time(logevent);
    } else {
      console.timeEnd(logevent);
    }
  }
}

// utility function to format numbers in 123,456,789.12 format
function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// TODO aggregation label feature - pending ag-grid support
// // grouping injects a new column where we should move our pinned bottom row aggregation labels
// function onColumnRowGroupChanged() {
//   onFilterChanged();
// }

/* Called when a column is added / removed (hidden).

   If no sparklines are visible after this call, row heights will be adjusted via getRowHeight() to
   look like a standard report.

   Only re-eval heights if at least one sparkline is present on a report and the user is either
   removing or adding back at least one sparkline column (perf).
*/
function onColumnVisible(event) {
  if (sparklinePresent && event.columns.some(o => o.colDef.valueType === 'sparkline')) {
    gridOptions.api.resetRowHeights();
  }
}

// agGrid calls this when a filter has been applied (updates grid, graphs, maps, etc.)
// You can additionally call this directly if your custom client code changes the data (perhaps after a live poll)
function onFilterChanged() {
  const filteredAverageAggregations = {};
  const filteredAverageEmptyCellCounters = {}; // disallows empty cells from skewing averages
  const filteredTotalAggregations = {};
  let columnsExistToAggregate = false;
  pinnedBottomRowData = [];

  // we calculate filtered aggs in the same new row data pass regardless if filter is set
  // (we have to get updated row data anyways, might as well)
  for (const i of Object.keys(columnDefs)) {
    if (_.includes(['currency', 'double', 'integer'], columnDefs[i].valueType)) {
      columnsExistToAggregate = true;
      filteredTotalAggregations[columnDefs[i].field] = 0; // we init to 0 so accumulators work later
      filteredAverageAggregations[columnDefs[i].field] = 0; // supports case where filter results in no rows
      filteredAverageEmptyCellCounters[columnDefs[i].field] = 0;
    }
  }

  // extract new row data from grid model and update rowDataTyped for widgets (requires casting against the known column types)
  // also calculate filtered aggregations
  rowDataTyped = []; // reset rowDataTyped

  gridOptions.api.forEachNodeAfterFilter(rowNode => {
    if (!rowNode.group) {
      const nextRowDataTyped = _.clone(rowNode.data); // leave grid data untouched

      // at this point, nextRowDataTyped is currently untyped grid string data
      // cast where necessary to make accurate rowDataTyped for widgets and aggregations
      let numericValue = 0;
      columnDefs.forEach(columnDef => {
        switch (columnDef.valueType) {
          case 'currency':
          case 'double':
            if (nextRowDataTyped[columnDef.field] === '') {
              nextRowDataTyped[columnDef.field] = 0.0;
              filteredAverageEmptyCellCounters[columnDef.field] += 1;
            } else {
              numericValue = parseFloat(nextRowDataTyped[columnDef.field]);
              nextRowDataTyped[columnDef.field] = numericValue;
              filteredTotalAggregations[columnDef.field] += numericValue;
            }
            break;
          case 'integer':
            if (nextRowDataTyped[columnDef.field] === '') {
              nextRowDataTyped[columnDef.field] = 0;
              filteredAverageEmptyCellCounters[columnDef.field] += 1;
            } else {
              numericValue = parseInt(nextRowDataTyped[columnDef.field], 10);
              nextRowDataTyped[columnDef.field] = numericValue;
              filteredTotalAggregations[columnDef.field] += numericValue;
            }
            break;
          default:
            // default, leave data alone
            break;
        }
      });

      rowDataTyped.push(nextRowDataTyped);
    }
  });

  // TODO aggregation label feature - pending ag-grid support, needs filtered agg support below as well
  // // There may be a cleaner way to detect grouping, but I didn't find it in the docs.
  // const groupingActive = gridOptions.columnApi.getColumnState()[0].colId === 'ag-Grid-AutoColumn';

  // // Update aggregation label placement, if used (col 0 rubric described elsewhere)
  // if (_.has(columnDefs, '0')) {
  //   if (groupingActive) {
  //     delete averageAggregations[columnDefs[0].field];
  //     delete totalAggregations[columnDefs[0].field];
  //     averageAggregations['ag-Grid-AutoColumn'] = 'Average';
  //     totalAggregations['ag-Grid-AutoColumn'] = 'Total';
  //   } else {
  //     delete averageAggregations['ag-Grid-AutoColumn'];
  //     delete totalAggregations['ag-Grid-AutoColumn'];
  //     averageAggregations[columnDefs[0].field] = 'Average';
  //     totalAggregations[columnDefs[0].field] = 'Total';
  //   }
  // }

  // update result count display
  if (gridOptions.api.isAnyFilterPresent()) {
    rowCountSpan.innerHTML = `${numberWithCommas(rowDataTyped.length)} of ${numberWithCommas(rowCount)} Results`;

    // display filtered aggregations if requested
    if (columnsExistToAggregate && rowDataTyped.length > 0) {
      for (const i of Object.keys(columnDefs)) {
        let activeRowCount = 0; // do not count "blank" numeric cells in average calculations
        switch (columnDefs[i].valueType) {
          case 'currency': // see the valueFormatter function for currencies in getColumnDefs() for formatting
          case 'double':
            activeRowCount = rowDataTyped.length - filteredAverageEmptyCellCounters[columnDefs[i].field];
            filteredAverageAggregations[columnDefs[i].field] = (
              filteredTotalAggregations[columnDefs[i].field] / (activeRowCount || 1)
            ).toFixed(columnDefs[i].precision);
            filteredTotalAggregations[columnDefs[i].field] = filteredTotalAggregations[columnDefs[i].field].toFixed(
              columnDefs[i].precision
            );
            break;
          case 'integer': // shouldn't need this one if we receive true integers - safety
            activeRowCount = rowDataTyped.length - filteredAverageEmptyCellCounters[columnDefs[i].field];
            filteredAverageAggregations[columnDefs[i].field] = Math.ceil(
              filteredTotalAggregations[columnDefs[i].field] / (activeRowCount || 1)
            );
            filteredTotalAggregations[columnDefs[i].field] = Math.ceil(filteredTotalAggregations[columnDefs[i].field]);
            break;
          default:
            break;
        }

        // Consult YAML settings to any aggregations that should be supressed.
        // While we could design the code to not aggregate in the first place under that condition, the
        // code would end up overly complicated and preoptimized for no noticable gain, even on
        // huge data sets.  Pooters add fast AF.
        if (columnDefs[i].suppressAverageAggregation) {
          delete filteredAverageAggregations[columnDefs[i].field];
        }
        if (columnDefs[i].suppressTotalAggregation) {
          delete filteredTotalAggregations[columnDefs[i].field];
        }
      }
    }

    // Ben stated he designed reports to assume column 0 is always apropos to place aggregation labels.
    // Nevertheless, only do so if a column 0 actually exists.
    if (_.has(columnDefs, '0')) {
      filteredAverageAggregations[columnDefs[0].field] = 'Filtered Average';
      filteredTotalAggregations[columnDefs[0].field] = 'Filtered Total';
    }

    if (reportAverageAggregations) {
      pinnedBottomRowData.push(averageAggregations);
      pinnedBottomRowData.push(filteredAverageAggregations);
    }
    if (reportTotalAggregations) {
      pinnedBottomRowData.push(totalAggregations);
      pinnedBottomRowData.push(filteredTotalAggregations);
    }
  } else {
    // no filter present
    rowCountSpan.innerHTML = `${numberWithCommas(rowCount)} Results`;

    // this clears any filtered aggregations from displaying
    if (reportAverageAggregations) {
      pinnedBottomRowData.push(averageAggregations);
    }
    if (reportTotalAggregations) {
      pinnedBottomRowData.push(totalAggregations);
    }
  }

  gridOptions.api.setPinnedBottomRowData(pinnedBottomRowData);

  // rerun dataProvider transform on each graph then validateData() to update graphs
  chartObjs.forEach(chartObj => {
    chartObj.chart.dataProvider = chartObj.dataProviderTransform(rowDataTyped);
    chartObj.chart.validateData();
  });

  if (
    _.includes(['AAR6A', 'AAR6B', 'AAR6C', 'APR4', 'AST5', 'PMR4', 'PMR4A'], reportConfig.reportName) &&
    mapboxObjs.length !== 0
  ) {
    zipcodes = [];
    const dataLength = rowDataTyped.length;
    for (let j = 0; j < dataLength; j++) {
      zipcodes.push(rowDataTyped[j].zipcode);
    }
    zipcodes = _.countBy(zipcodes, zipcode => {
      // sanitize, unique filter, and count the codes client side
      // remove spaces
      if (~zipcode.indexOf(' ')) {
        zipcode = zipcode.replace(/ /g, '');
      }
      // extract only portion before . if present
      if (~zipcode.indexOf('.')) {
        zipcode = zipcode.split('.')[0];
      }
      // extract non-extended portion of US zipcodes that provide it
      if (~zipcode.indexOf('-')) {
        zipcode = zipcode.split('-')[0];
      }
      return zipcode;
    });

    // clear the existing mapbox layers (circle points)
    mapboxObjs.forEach(mapboxObj => {
      mapboxObj.map.eachLayer(layer => {
        if (_.has(layer, '_latlng')) {
          mapboxObj.map.removeLayer(layer);
        }
      });
    });

    showMapPoints();
  }
}

Drilldown.setGridRefresh(onFilterChanged);

// Simply close modal (discard option changes)
// Evented when user hits Cancel on options modal
function optionsCancel() {
  optionsModal.close();
  pikaDayHide();
}

/* This is usually evented by the user hitting Save on the options dialog, but it's possible
   this is ran directly (for example an optionless report with no cache option, thus no reason
   to show the options modal).  Just make sure the options exist in the DOM before calling this
   one way or another via renderOptionsFormModal().  This function works regardless of if the
   optionsModal is popped.
*/
function optionsSaveAndRun() {
  // reportOptions.label(s)/type(s) are set when the options are parsed in renderOptionsFormModal()

  if (validateOptions()) {
    for (let i = 0; i < reportOptions.length; i++) {
      // .value is the parameter sent to D3/QM, .displayValue is the tag value displayed to the user
      if (reportOptions[i].type === 'boolean') {
        reportOptions[i].value = document.getElementById(`option${i}`).checked ? 'Y' : 'N';
        reportOptions[i].displayValue = reportOptions[i].value;
      } else if (reportOptions[i].type === 'select') {
        const selectOption = document.getElementById(`option${i}`);
        reportOptions[i].value = selectOption.value;
        reportOptions[i].displayValue = selectOption.options[selectOption.selectedIndex].innerHTML;
      } else if (reportOptions[i].type === 'search') {
        const spacedValues = $(`#option${i}`).tagsinput('items').join(' ');
        reportOptions[i].value = spacedValues;
        reportOptions[i].displayValue = reportOptions[i].value;
      } else if (reportOptions[i].type === 'multi') {
        const multiSelectOptions = document.getElementById(`option${i}`).options;
        const values = [];
        for (let j = 0; j < multiSelectOptions.length; j++) {
          if (multiSelectOptions[j].selected) {
            values.push(multiSelectOptions[j].value);
          }
        }
        if (values.length) {
          reportOptions[i].value = values.join('|');
          reportOptions[i].displayValue = reportOptions[i].value;
        } else {
          reportOptions[i].value = '';
          reportOptions[i].displayValue = '';
        }
      } else {
        // text, date, number, hidden
        reportOptions[i].value = document.getElementById(`option${i}`).value;
        reportOptions[i].displayValue = reportOptions[i].value;
      }

      // Though the YAML specifies null for some hidden values, D3/QM expects empty string (||)
      // displayValue will remain 'null', but actual value sent to D3/QM will be empty
      if (reportOptions[i].type === 'hidden' && reportOptions[i].value === 'null') {
        reportOptions[i].value = '';
      }
    }

    updatePersistedReportOptions();

    showOptionsSetDiv(renderOptionTags());

    if (cacheDisabled && !hasVisibleOptions && !multibranchAvailable) {
      //
    } else {
      pikaDayHide();
      optionsModal.close();
      showOptionsButton.focus();
    }

    showResults();
  }
}

function parseDataLines(dataLines) {
  rowData = []; // reset rowdata (strings)
  rowDataTyped = []; // reset raw widget data
  averageAggregations = {}; // keyed on column field
  totalAggregations = {}; // keyed on column field
  const averageEmptyCellCounters = {}; // disallows empty cells from skewing averages
  let columnsExistToAggregate = false;
  pinnedBottomRowData = []; // could include Average / Subtotal / Total rows - empty shows nothing

  // Init column aggregations (apply to currency, double, & integer columns)
  // Aggregations get calculated by default for simpler code.
  // We rely on YAML aggregation options only to determine if the results should be displayed.
  for (const i of Object.keys(columnDefs)) {
    if (_.includes(['currency', 'double', 'integer'], columnDefs[i].valueType)) {
      columnsExistToAggregate = true;
      totalAggregations[columnDefs[i].field] = 0; // we init to 0 so accumulators work later
      averageEmptyCellCounters[columnDefs[i].field] = 0;
    }
  }

  // use vanilla for loops + length caching here for performance parsing data
  let columnMismatch = false;
  mismatches = []; // reset

  const dataLinesCount = dataLines.length;
  rowCount = 0;
  for (let i = 0; i < dataLinesCount; i++) {
    // 1st row is column defs on dynamicReports
    if (dynamicReport && i === 0) {
      continue;
    }
    // split might add one empty line
    if (!!dataLines[i]) {
      rowCount++;
      const gridLine = {}; // all strings for display
      const dataLineTyped = {}; // maintains types (for widgets, etc.)
      const parsedLine = dataLines[i].split('ý');
      const parsedFieldCount = parsedLine.length + (autoRefreshSecs ? 1 : 0);

      /* Detect mismatch between YAML column count and returned data column count for static reports.
         This occurs when the returned data has more columns than defined in the YAML, or vice versa.
         Only columns defined in the YAML will be rendered to the grid upon mismatch, matching defined
         index positions to field positions.
      */
      if (!dynamicReport && columnDefs.length !== parsedFieldCount) {
        // log the mismatch
        mismatches.push({
          columnDefs,
          countColumnDefs: columnDefs.length,
          countParsedRow: parsedFieldCount,
          parsedRow: parsedLine,
          rawRow: dataLines[i],
          rowNumber: i, // 0-indexed
        });
        columnMismatch = true;
      }

      // match indexes defined in YAML
      // skips any column not defined in the YAML with corresponding index
      for (let j = 0; j < parsedFieldCount; j++) {
        let numericValue = 0;
        if (!_.isUndefined(columnDefs[j])) {
          switch (columnDefs[j].valueType) {
            case 'currency':
              if (parsedLine[j] === 'COST') {
                parsedLine[j] = 0.0;
              }
              if (parsedLine[j] === '') {
                averageEmptyCellCounters[columnDefs[j].field] += 1;
                dataLineTyped[columnDefs[j].field] = 0.0;
                gridLine[columnDefs[j].field] = '';
              } else {
                numericValue = Number(parsedLine[j]);
                totalAggregations[columnDefs[j].field] += numericValue;
                dataLineTyped[columnDefs[j].field] = numericValue;
                gridLine[columnDefs[j].field] = numericValue;
              }
              break;
            case 'double':
              if (parsedLine[j] === '') {
                averageEmptyCellCounters[columnDefs[j].field] += 1;
                dataLineTyped[columnDefs[j].field] = 0.0;
                gridLine[columnDefs[j].field] = '';
              } else {
                numericValue = Number(parsedLine[j]);
                totalAggregations[columnDefs[j].field] += numericValue;
                dataLineTyped[columnDefs[j].field] = numericValue;
                gridLine[columnDefs[j].field] = numericValue;
              }
              break;
            case 'integer':
              if (parsedLine[j] === '') {
                averageEmptyCellCounters[columnDefs[j].field] += 1;
                dataLineTyped[columnDefs[j].field] = 0;
                gridLine[columnDefs[j].field] = '';
              } else {
                numericValue = Number(parsedLine[j]);
                totalAggregations[columnDefs[j].field] += numericValue;
                dataLineTyped[columnDefs[j].field] = numericValue;
                gridLine[columnDefs[j].field] = numericValue;
              }
              break;
            case 'sparkline':
              dataLineTyped[columnDefs[j].field] = []; // unused

              /* Two formats available:
                 Simple Data: 3~5~3
                 Tagged Data (Tuples): A::3~B::5~C::3 (for labels)
              */

              // Tuple data?
              if (~parsedLine[j].indexOf('::')) {
                const tupleData = [];
                const tuples = parsedLine[j].split('~');
                for (const tuple of tuples) {
                  const [tag, value] = tuple.split('::');
                  tupleData.push([tag, Number(value)]);
                }
                gridLine[columnDefs[j].field] = tupleData;

                // Otherwise simple data
              } else {
                gridLine[columnDefs[j].field] = parsedLine[j].split('~').map(o => Number(o));
              }
              break;
            case 'string':
            default:
              dataLineTyped[columnDefs[j].field] = parsedLine[j];
              gridLine[columnDefs[j].field] = parsedLine[j];
              break;
          }
        }
      }

      rowData.push(gridLine); // used by ag-grid
      rowDataTyped.push(dataLineTyped); // used by widgets and anything else needing typed data
    }
  }

  if (columnMismatch) {
    console.error('COLUMN MISMATCH DETECTED!\nSee reportModule.debug().mismatches');

    if (user.username === 'dsisupport') {
      toastr.error('Error', 'Column Mismatch Detected!');
      console.log(debug().mismatches);
    }
  }

  // calculate average aggregations and format all aggregations for display
  // skips if there's no aggregatable columns or no data rows
  if (columnsExistToAggregate && rowCount > 0) {
    for (const i of Object.keys(columnDefs)) {
      let activeRowCount = 0; // do not count "blank" numeric cells in average calculations
      switch (columnDefs[i].valueType) {
        case 'currency': // see the valueFormatter function for currencies in getColumnDefs() for formatting
        case 'double':
          activeRowCount = rowCount - averageEmptyCellCounters[columnDefs[i].field];
          averageAggregations[columnDefs[i].field] = (
            totalAggregations[columnDefs[i].field] / (activeRowCount || 1)
          ).toFixed(columnDefs[i].precision);
          totalAggregations[columnDefs[i].field] = totalAggregations[columnDefs[i].field].toFixed(
            columnDefs[i].precision
          );
          break;
        case 'integer': // shouldn't need this one if we receive true integers - safety
          activeRowCount = rowCount - averageEmptyCellCounters[columnDefs[i].field];
          averageAggregations[columnDefs[i].field] = Math.ceil(
            totalAggregations[columnDefs[i].field] / (activeRowCount || 1)
          );
          totalAggregations[columnDefs[i].field] = Math.ceil(totalAggregations[columnDefs[i].field]);
          break;
        default:
          break;
      }

      // Consult YAML settings to any aggregations that should be supressed.
      // While we could design the code to not aggregate in the first place under that condition, the
      // code would end up overly complicated and preoptimized for no noticable gain, even on
      // huge data sets.  Pooters add fast AF.
      if (columnDefs[i].suppressAverageAggregation) {
        delete averageAggregations[columnDefs[i].field];
      }
      if (columnDefs[i].suppressTotalAggregation) {
        delete totalAggregations[columnDefs[i].field];
      }
    }

    // Ben stated he designed reports to assume column 0 is always apropos to place aggregation labels.
    // Nevertheless, only do so if a column 0 actually exists.
    if (_.has(columnDefs, '0')) {
      averageAggregations[columnDefs[0].field] = 'Average';
      totalAggregations[columnDefs[0].field] = 'Total';
    }

    // Consult YAML for overall aggregation enable
    reportAverageAggregations = false;
    reportTotalAggregations = false;
    if (_.has(reportConfig.config, 'page.Report.aggs')) {
      if (_.includes(reportConfig.config.page.Report.aggs, 'average')) {
        reportAverageAggregations = true;
        pinnedBottomRowData.push(averageAggregations);
      }
      if (_.includes(reportConfig.config.page.Report.aggs, 'totals')) {
        reportTotalAggregations = true;
        pinnedBottomRowData.push(totalAggregations);
      }
    }
  }

  /* Final note on aggregations: average/total aggregations are global to this module
     so that filtered results sets can prepend to them in order to add filtered aggregations
     to the pinned bottom row in ag-grid.

     The filter code infers which filtered aggregations should be added based on keys present
     in averageAggregations/totalAggregations, so you need not re-consider the YAML settings
     when applying filters.
  */
}

// Hide pikaDay objects after options modal closes.
// These objects were created during renderOptionsFormModal()
// Required if calendar is showing when ESC is pressed.
function pikaDayHide() {
  pikaDayObjs.forEach(pikaDayObj => {
    pikaDayObj.hide();
  });
}

function calculateGridHeight() {
  const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  const gridTop = gridDiv.getBoundingClientRect().top;

  let gridHeight = viewportHeight - gridTop - 15;
  gridHeight = gridHeight > 375 ? gridHeight : 375; // fixes mobile issue - always make grid AT LEAST 375px
  gridDiv.style.height = `${gridHeight}px`;
}

// Filter all columns - note this is throttled in report.js to prevent rapid recomputation
function quickFilter(value) {
  gridOptions.api.setQuickFilter(quickFilterInput.value);
  if (!!value) {
    searchClearButton.style.display = 'block';
  } else {
    searchClearButton.style.display = 'none';
  }
}

/* Iterates over each page option in reportConfig.config and renders each control accordingly.
   Controls are IDed in order, simply, as option0 ... optionN, for later use and submission to
   bifrost for D3/QM results.  showOptions() has already determined valid options exist.
   Supports dynamic options (via D3/QM subprogram) for dates & selects.
   innerHTML rendered into options modal in report-spa.njk.
*/
function renderOptionsFormModal(optionsSeed = null, branchesSeed = null) {
  let optionsFormRender = '';
  let optionID = 0; // incremented as each control renders
  const dateFields = []; // init Pikaday for dates after fields are rendered into the DOM
  let options = _.get(reportConfig, 'config.page.options', []);

  // prevents possible bug if YAML specifies options without correct array syntax (previously SMF2)
  // 3 reports in question were fixed externally in the YAML, but this is a good fail safe anyway
  if (!Array.isArray(options)) {
    const optionsFixed = [options];
    options = optionsFixed;
  }

  for (const option of options) {
    // skip malformed options, must have type
    if (_.has(option, 'type')) {
      const label = _.get(option, 'label', `UNDEF${optionID}`).trim(); // failsafe for missing label
      const pattern = _.get(option, 'validators.pattern', '');
      const ppcautofill = _.get(option, 'ppcautofill', false);
      const techautofill = _.get(option, 'techautofill', false);
      const required = _.get(option, 'validators.required', false);
      const skiplayouthash = _.get(option, 'skiplayouthash', false);
      const todaycheckbox = _.get(option, 'todaycheckbox', false); // only used by date fields
      const yesterdaycheckbox = _.get(option, 'yesterdaycheckbox', false) || todaycheckbox; // Just turn this on if today is used for now
      const todayString = moment().format('MM-DD-YY');
      const yesterdayString = moment().subtract(1, 'day').format('MM-DD-YY');

      let value = ''; // used by hidden fields and dynamic dates

      reportOptions[optionID] = {
        label,
        type: option.type,
        required,
        pattern,
        skiplayouthash,
        todaycheckbox,
        yesterdaycheckbox,
      };

      // any control defined with an unknown type will be rendered as text box
      // relative positioning on control-containing divs is a vestige of errors absolutely positioned
      // which we may revert to again in the future
      switch (option.type) {
        case 'boolean':
          hasVisibleOptions = true;
          optionsFormRender += `
          <div class="form-group">
            <label for="option${optionID}">${label}</label>
            <div class="checkbox">
                <label>
                  <input type="checkbox" name="option${optionID}" id="option${optionID}">Yes
                </label>
            </div>
          </div>
          `;
          break;

        case 'date':
          hasVisibleOptions = true;
          value = '';
          // check for dynamic option injected date
          if (_.has(option, 'dynamic')) {
            value = _.get(option, 'value', '');
          }
          // end check for dynamic option injected date
          optionsFormRender += `
          <div class="form-group">
            <label for="option${optionID}">${label}</label>
            <div class="input-group" style="position:relative">
              <div class="input-group-addon" id="option${optionID}cal"><i class="zmdi zmdi-calendar" style="font-size:18px"></i></div>
              <div style="flex-grow: 1">
              <input
                type="text"
                value="${value}"
                name="option${optionID}"
                id="option${optionID}"
                class="form-control"
                placeholder="MM-DD-YY"
                onchange="
                  reportModule.clearError(${optionID});
                  if(${todaycheckbox}) {
                     if (this.value !== '${todayString}') {
                      document.getElementById('option${optionID}today').checked = false;
                     }
                  }
                  if(${yesterdaycheckbox}) {
                    if (this.value !== '${yesterdayString}') {
                      document.getElementById('option${optionID}yesterday').checked = false;
                    }
                 }"
                oninput="reportModule.clearError(${optionID})"
              />
              <div class="date-controls">`;

          if (todaycheckbox) {
            optionsFormRender += `
                <input
                  id="option${optionID}today"
                  type="checkbox"
                  style="margin-top:10px"
                  onclick="
                    document.getElementById('option${optionID}').value = '${todayString}';
                    reportModule.clearError(${optionID});
                    if(${yesterdaycheckbox}) {
                      document.getElementById('option${optionID}yesterday').checked = false;
                    }
                  "
                >Today
            `;
          }

          if (yesterdaycheckbox) {
            optionsFormRender += `
                <input
                  id="option${optionID}yesterday"
                  type="checkbox"
                  style="margin-top:10px"
                  onclick="
                    document.getElementById('option${optionID}').value = '${yesterdayString}';
                    reportModule.clearError(${optionID});
                    if(${todaycheckbox}) {
                      document.getElementById('option${optionID}today').checked = false;
                    }
                    "
                >Yesterday
            `;
          }

          optionsFormRender += `
              </div>
              <div class="formError" id="formError${optionID}">Invalid Date</div>
            </div>
            </div>
          </div>
          `;
          dateFields.push(optionID); // track to attach pikaday later (after DOM rendered)
          break;

        case 'hidden':
          value = _.get(option, 'value', ''); // failsafe for missing value

          // ppcautofill dominates value key on hidden option types, if both are present
          value = ppcautofill ? user.ppc : value;
          value = techautofill ? user.technicianId : value;

          optionsFormRender += `
          <input type="hidden" name="option${optionID}" id="option${optionID}" value="${value}" />
          `;
          break;

        case 'multi':
          hasVisibleOptions = true;
          bsSelectObjs.push(`option${optionID}`);
          optionsFormRender += `
          <div class="form-group">
            <label for="option${optionID}">${label}</label>
            <select name="option${optionID}" id="option${optionID}" class="form-control" multiple/>
          `;

          const multiSelectOptions = _.get(option, 'options', []); // failsafe for missing options on select

          if (multiSelectOptions.length === 0) {
            optionsFormRender += `
            <option value="">UNDEFINED</option>
            `;
          } else {
            // utilize seed options if available to set selectedValues array
            let selectedValues = _.get(optionsSeed, optionID, '');
            if (selectedValues) {
              selectedValues = selectedValues.split('|');
            } else {
              selectedValues = [];
            }

            for (const selectOption of multiSelectOptions) {
              // seed selected where appropriate
              let selectedAttr = '';
              if (_.includes(selectedValues, selectOption.value)) {
                selectedAttr = 'selected';
              }

              optionsFormRender += `
              <option value="${selectOption.value}" ${selectedAttr}>${selectOption.label}</option>
              `;
            }
          }

          optionsFormRender += `
            </select>
          </div>
          `;
          break;

        case 'number':
          hasVisibleOptions = true;
          // currently always 1-12, but could change in the future
          const min = _.get(option, 'validators.min', '');
          const max = _.get(option, 'validators.max', '');
          // check for dynamic option injected
          if (_.has(option, 'dynamic')) {
            value = _.get(option, 'value', '');
          }
          optionsFormRender += `
          <div class="form-group">
            <label for="option${optionID}">${label}</label>
            <div style="position:relative">
              <input type="number" name="option${optionID}" id="option${optionID}" class="form-control"
              oninput="reportModule.clearError(${optionID})" min="${min}" max="${max}" value="${value}"/>
              <div class="formError" id="formError${optionID}">Invalid Number</div>
            </div>
          </div>
          `;
          break;

        case 'select':
          hasVisibleOptions = true;
          optionsFormRender += `
          <div class="form-group">
            <label for="option${optionID}">${label}</label>
            <select name="option${optionID}" id="option${optionID}" class="form-control" />
          `;

          const selectOptions = _.get(option, 'options', []); // failsafe for missing options on select
          if (selectOptions.length === 0) {
            optionsFormRender += `
            <option value="">UNDEFINED</option>
            `;
          } else {
            if (Array.isArray(selectOptions)) {
              /* Dynamic options are always specified in array form:
                 [ {label:, value:}, ...]

                 These can be specified statically in YAML via:
                 options:
                   - label: With or Without Locations
                     value: Locations
                   - label: Without Locations
                     value: No_Locations

                 This format supports numerical labels which are NOT promoted to first positions.
              */
              for (const selectOption of selectOptions) {
                optionsFormRender += `
                <option value="${_.get(selectOption, 'value', '')}">${_.get(selectOption, 'label', '')}</option>
                `;
              }
            } else {
              /* Legacy YAML databridge support wherein options are defined in the YAML as objects:
                 options:
                   With Or Without Locations: Locations
                   Without Locations: No_Locations

                 This format suffers from numeric "labels" (keys) being promoted to first positions.
              */
              for (const selectOption of Object.keys(selectOptions)) {
                optionsFormRender += `
                <option value="${option.options[selectOption]}">${selectOption}</option>
                `;
              }
            }
          }

          optionsFormRender += `
            </select>
          </div>
          `;
          break;

        case 'search':
          hasVisibleOptions = true;
          bsTagsObjs.push({
            id: `option${optionID}`,
            options: _.get(option, 'options', null),
          });

          optionsFormRender += `
          <div class="form-group">
            <label for="option${optionID}">${label}</label>
            <div style="position:relative">
              <input type="text" name="option${optionID}" id="option${optionID}" onchange="reportModule.clearError(${optionID})"/>
              <div class="formError" id="formError${optionID}">Invalid Text</div>
            </div>
          </div>
          `;
          break;

        case 'text':
        default:
          hasVisibleOptions = true;
          value = ppcautofill ? user.ppc : '';

          optionsFormRender += `
          <div class="form-group">
            <label for="option${optionID}">${label}</label>
            <div style="position:relative">
              <input type="text" name="option${optionID}" id="option${optionID}" class="form-control" oninput="reportModule.clearError(${optionID})" value="${value}"/>
              <div class="formError" id="formError${optionID}">Invalid Text</div>
            </div>
          </div>
          `;
          break;
      }

      optionID++;
    }
  }

  /* Render multibranch options if this user has the ability to run this report on branches
     other than his/her currently active branch and multibranch hasn't been disabled in the YAML.

     Branch info is not passed around on generated sharelinks.
  */
  if (!multibranchDisabled) {
    /* reportModule.debug().user; from the console is useful to debug this!
       - user.branch.id is currently active branch
       - user.branches[] contains all branches associated with this user (we'll use .id & .name properties)
       - each user.branches[] has an associated companyId
       - user.companies[] contains company info, each object has an id property
       - reportConfig.config.branchesAllowed[] contains branch IDs this user has perms
         for calculated when we fetched the reportConfig for this user

      If the report loads for the user, one can infer he/she has permissions at least for this branch.
    */
    const branchesAllowed = reportConfig.config.branchesAllowed;
    if (!(branchesAllowed.length === 1 && branchesAllowed[0] === user.branch.id)) {
      // If user has permission to run this report on branches other than the currently active branch,
      // render a branch selection control for those branches. Otherwise, no need.

      // multibranchDisabled is explicit in the YAML for everyone, multibranchAvailable is calculated per user
      multibranchAvailable = true;
      bsSelectObjs.push('multibranchSelection');
      optionsFormRender += `
      <div class="form-group">
        <label for="multibranchSelection">Branch Selection</label>
        <div style="position:relative">
        <select name="multibranchSelection" id="multibranchSelection" class="form-control" multiple />
      `;

      // safeguard - should be okay, but stupid happens
      if (branchesSeed && !Array.isArray(branchesSeed)) {
        branchesSeed = null;
      }

      // keyed on company names for optgroups - each key has an array of branches
      const branchSelectOptions = {};

      // At this point all we have is an array of branch IDs we have permission for.
      // Match up the IDs to textual info to render in the control
      for (const branchID of branchesAllowed) {
        // The user system SHOULD give us the branch info, but make no assumptions (corrupt data, etc.)
        const branchInfo = _.find(user.branches, o => o.id === branchID);

        // If we found no branch info, just skip it as a branch option - something is errnoeous somewhere
        if (!_.isUndefined(branchInfo)) {
          // The user system SHOULD also give us the company info (to title the optgroup appropriately),
          // but make no assumptions (corrupt data, etc.).  Non-fatal, assign to "Other" if not found.
          let companyInfo = _.find(user.companies, o => o.id === branchInfo.companyId);
          if (_.isUndefined(companyInfo)) {
            companyInfo = { name: 'Other' };
          }

          let selected = '';

          // auto select the user's active branch if no branch seed provided
          if (branchesSeed === null) {
            selected = user.branch.id === branchID ? 'selected' : '';
          } else {
            // see if this branch is selected in the seed
            selected = _.includes(branchesSeed, branchID.toString()) ? 'selected' : '';
          }

          // build branch option obj
          const option = {
            id: branchID,
            name: branchInfo.name,
            selected,
          };

          // assign it to the right company (optgroup)
          if (companyInfo.name in branchSelectOptions) {
            branchSelectOptions[companyInfo.name].push(option);
          } else {
            branchSelectOptions[companyInfo.name] = [option];
          }
        }
      }

      // Render the company optgroups sorted so users can spot things easier
      for (const companyName of Object.keys(branchSelectOptions).sort()) {
        optionsFormRender += `<optgroup label="${companyName}">`;

        // Also sort the individual branches within each company optgroup
        branchSelectOptions[companyName].sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        // Actually render the option
        for (const option of branchSelectOptions[companyName]) {
          optionsFormRender += `<option value="${option.id}" ${option.selected}>${option.name}</option>`;
        }

        optionsFormRender += '</optgroup>';
      }

      optionsFormRender += `
        </select>
        <div class="formError" id="formErrorMultibranchSelection">Invalid Text</div>
        </div>
      </div>
      `;
    }
  }

  if (
    !dynamicReport &&
    Array.isArray(reportConfig.userSettings.myLayoutOptions) &&
    Array.isArray(reportConfig.userSettings.publicLayoutOptions)
  ) {
    const { myLayoutOptions, publicLayoutOptions } = reportConfig.userSettings;

    if (myLayoutOptions.length > 0 || publicLayoutOptions.length > 0) {
      bsSelectObjs.push('optionLayoutId');

      optionsFormRender += `
        <div class="form-group">
          <label for="optionLayoutId">Apply Saved Layout</label>
          <select name="optionLayoutId" id="optionLayoutId" class="form-control" />
             <option value="default">Default (No Custom Layout)</option>
          `;

      if (myLayoutOptions.length > 0) {
        optionsFormRender += `
             <optgroup label="My Layouts">
        `;

        for (const myLayoutOption of myLayoutOptions) {
          optionsFormRender += `
               <option value="${myLayoutOption.id}" ${myLayoutOption.id === activeLayoutId ? 'selected' : ''}>${
            myLayoutOption.name
          }</option>
           `;
        }

        optionsFormRender += `
             </optgroup>
        `;
      }

      // Public layout options from other users.  This user's public layouts are included in "My Layouts" already.
      if (publicLayoutOptions.length > 0) {
        optionsFormRender += `
             <optgroup label="Public Layouts">
        `;

        for (const publicLayoutOption of publicLayoutOptions) {
          optionsFormRender += `
                <option value="${publicLayoutOption.id}" ${
            publicLayoutOption.id === activeLayoutId ? 'selected' : ''
          }>${publicLayoutOption.name}</option>
           `;
        }

        optionsFormRender += `
             </optgroup>
        `;
      }

      optionsFormRender += `
          </select>
        </div>`;
    }
  }

  /* fetchReportData looks to id:useCache to determine if a cache flag should be passed
     to the server.  If caching is disabled, the shortest path of resistance is to still
     render the control to the DOM for reading useCache:false later, just hide the option.
     The server ignores the setting regardless if cache is disabled.
  */
  const cacheDivStyle = cacheDisabled ? 'display:none' : '';
  optionsFormRender += `
  <div class="form-group" style="${cacheDivStyle}">
    <div class="checkbox" style="margin-top:30px">
        <label>
          <input type="checkbox" name="useCache" id="useCache">Re-display Recent Results If Available? (Faster)
        </label>
    </div>
  </div>`;

  /* Offer the user a chance to save report options to their user profile, if any visible options exist.
     Note branch selection and cache options do not count towards visible options.
  */
  const saveOptionsDivStyle = !hasVisibleOptions && !multibranchAvailable ? 'display:none' : '';
  const saveOptionsChecked = seededOptionsFromUserProfile ? 'checked' : '';
  optionsFormRender += `
  <div class="form-group" style="${saveOptionsDivStyle}">
    <div class="checkbox" style="margin-top:20px">
        <label>
          <input type="checkbox" name="saveOptionsForNextRun" id="saveOptionsForNextRun" ${saveOptionsChecked}>Save options for future runs?
        </label>
    </div>
  </div>`;

  if (dynamicReport) {
    optionsFormRender += `
    <div>
      * As a dynamic report, different data columns may be shown based on the options selected.
    </div>
    `;
  }

  optionsForm.innerHTML = optionsFormRender; // render to DOM

  // bind Pikaday to all date controls previously pushed to dateFields Array
  // the controls must exist in the dom before binding Pikaday, which is why we do it here
  for (const id of dateFields) {
    pikaDayObjs.push(
      new Pikaday({
        field: document.getElementById(`option${id}`),
        format: 'MM-DD-YY',
        showDaysInNextAndPreviousMonths: true,
        trigger: document.getElementById(`option${id}cal`),
      })
    );
  }

  // bind bootstrap-select to any multi control (PMI1, PMI4, PMI5)
  for (let i = 0; i < bsSelectObjs.length; i++) {
    $(`#${bsSelectObjs[i]}`).selectpicker({
      actionsBox: true,
      selectedTextFormat: 'count',
    });
  }

  // bind bootstrap-tags/typeahead to any search control (e.g. ACU9)
  for (let i = 0; i < bsTagsObjs.length; i++) {
    // if list isn't specified, we revert to a vanilla tags input without typeahead
    const list = _.get(bsTagsObjs[i], 'options.list', null);
    const desccol = _.get(bsTagsObjs[i], 'options.desccol', 1);
    const freeInput = _.get(bsTagsObjs[i], 'options.freeinput', true);
    const multiSelect = _.get(bsTagsObjs[i], 'options.multiselect', true);
    const spaceToEnter = _.get(bsTagsObjs[i], 'options.spacetoenter', true);

    const widgets = $(`#${bsTagsObjs[i].id}`).tagsinput({
      confirmKeys: spaceToEnter ? [13, 32] : [13], // 13 = enter, 32 = space
      freeInput,
      maxTags: multiSelect ? undefined : 1,
      tagClass: 'bootstrap-tagsinput-tagstyle',
      typeaheadjs: [
        {
          highlight: true,
          minLength: 2,
        },
        {
          displayKey: 'display',
          valueKey: 'value',
          limit: Infinity, // resolve bug not showing all options: https://github.com/twitter/typeahead.js/issues/1232
          source: _.debounce((query, syncResults, asyncResults) => {
            if (list) {
              Api.get(`/list/${list}`, {
                params: {
                  q: query,
                  limit: 100,
                  skipAttachments: true,
                },
              })
                .then(res => {
                  const results = [];
                  res.data.list.forEach(item => {
                    const value = item.itemid; // by convention in our list indexes
                    const desc = item[Object.keys(item)[desccol]]; // which col to show as typeahead, defaults to 1
                    results.push({
                      value,
                      display: `${value} : ${desc}`,
                    });
                  });
                  asyncResults(results);
                })
                .catch(() => {
                  console.error(`Error retrieving data from list: ${list}.  Are you sure it exists?`);
                });
            }
          }, 200), // debounced to 200ms after last key, cut down on elastic calls
        },
      ],
    });

    // fix tabbing out of field issue on residual input text
    // https://github.com/bootstrap-tagsinput/bootstrap-tagsinput/issues/446
    if (freeInput) {
      widgets.forEach(widget => {
        const input = widget.input();
        input.focusout(() => {
          widget.add(input.val());
          input.typeahead('val', '');
        });
      });
    }
  }

  /* if options are seeded from a sharelink or stored options, apply the options now.
     Only do this if the option count is the same between the seed and the current config.
     There's a possibility the report has changed to include new options since the option
     save / link was generated.  There's also a possibilty option order has changed, but we'll
     accept that risk.  optionsSeed can only be set on an inital page load via init(), so
     subsequent report runs will run as expected, even if the URL still shows the share link.
  */
  if (optionsSeed !== null && reportOptions.length === optionsSeed.length) {
    for (let i = 0; i < optionsSeed.length; i++) {
      if (reportOptions[i].type === 'boolean') {
        if (optionsSeed[i] === 'Y') {
          document.getElementById(`option${i}`).checked = true;
        } else {
          document.getElementById(`option${i}`).checked = false;
        }
      } else if (reportOptions[i].type === 'multi') {
        // do nothing, seeding logic occurs when select is rendered
      } else if (reportOptions[i].type === 'search') {
        const tags = optionsSeed[i].split(' ');
        tags.forEach(tag => {
          $(`#option${i}`).tagsinput('add', tag);
        });
      } else if (reportOptions[i].type === 'select') {
        /* An edge case exists whereby a previously saved select option (or a previously
           used select option in a share link) has been REMOVED from the option values as
           specified in the YAML configuration.

           This occured 08/2017 when Ben removed a select option from AMS7.  Therefore,
           we must confirm the seeded option value still exists as an option in the report
           config before attempting to apply it.  In the event the option no longer exists,
           the rendered option form will select the first option in the list.
        */
        const el = document.getElementById(`option${i}`);
        for (let j = 0; j < el.options.length; j++) {
          if (el.options[j].value === optionsSeed[i]) {
            el.value = optionsSeed[i];
          }
        }
      } else if (reportOptions[i].type === 'date' && reportOptions[i].todaycheckbox) {
        if (optionsSeed[i] === 'TODAY') {
          const el = document.getElementById(`option${i}today`);
          // makes sure the option wasn't removed in the YAML after a save
          if (el) {
            el.checked = true;
          }
          document.getElementById(`option${i}`).value = moment().format('MM-DD-YY');
        } else if (optionsSeed[i] === 'YESTERDAY') {
          const el = document.getElementById(`option${i}yesterday`);
          // makes sure the option wasn't removed in the YAML after a save
          if (el) {
            el.checked = true;
          }
          document.getElementById(`option${i}`).value = moment().subtract(1, 'day').format('MM-DD-YY');
        } else {
          document.getElementById(`option${i}`).value = optionsSeed[i];
        }
      } else {
        document.getElementById(`option${i}`).value = optionsSeed[i];
      }
    }
  }
}

function renderOptionTags() {
  let render = '';
  reportOptions.forEach(reportOption => {
    if (reportOption.type !== 'hidden' && reportOption.displayValue !== '') {
      render += `<span class="badge badge-warning mr-1 p-1">${reportOption.label}: ${reportOption.displayValue}</span>\n`;
    }
  });
  return render;
}

// Removes all column filters, quick filters, and resets original column settings
// including order, sorts, grouping, size, etc..
// Note:  this does NOT destroy the current grid - rather it resets its settings
function resetGrid() {
  gridOptions.columnApi.resetColumnState();
  gridOptions.api.setFilterModel(null);
  gridOptions.api.setQuickFilter(null);
  gridOptions.api.onFilterChanged();
  quickFilterInput.value = '';
  searchClearButton.style.display = 'none';

  // re-move any columns which have a moveto specification in the YAML
  for (const index of Object.keys(columnDefs)) {
    if (columnDefs[index].moveto !== null) {
      // calculate the fromIndex after any movetos already applied!
      const columnState = gridOptions.columnApi.getColumnState();
      const fromIndex = _.findIndex(columnState, o => o.colId === columnDefs[index].field); // eslint-disable-line
      gridOptions.columnApi.moveColumnByIndex(fromIndex, columnDefs[index].moveto);
    }
  }

  // reapply aggFuncs
  applyAggFuncs();
}

// A user is running a subsequent report run via Options/Re-Run button and has toggled
// the default header orientation as specified in the YAML configuration for this report.
// Restore the header orientation to the default YAML config.
function resetHeaderOrientation() {
  const el = document.getElementById('gridDiv');
  const verticalHeadersEnabled = el.classList.contains('ag-vertical-headers');

  if (verticalHeadersDefault && !verticalHeadersEnabled) {
    el.classList.add('ag-vertical-headers');
  }

  if (!verticalHeadersDefault && verticalHeadersEnabled) {
    el.classList.remove('ag-vertical-headers');
  }
}

// Deletes any existing ag-grid resources, resets results UI
function resetResults() {
  clearInterval(autoRefreshIntervalObj);

  if (gridOptions !== null) {
    gridOptions.api.destroy();
    gridOptions = null;
  }

  columnDefs = null;

  // only used on 7 reports, but fast operation
  geocodes = null;
  zipcodes = null;

  clearGraphs();

  rowCountSpan.innerHTML = '';
  noDataDiv.style.display = 'none';
  actionButtonsDiv.style.display = 'none';
  quickFilterDiv.style.display = 'none';
  gridDiv.innerHTML = '';
}

function saveLayout() {
  // Set filters can be saved as long as there's not more than 25 items selected.
  // This prevents accidental set filter layout bloat (default selection might be huge).
  const filterState = gridOptions.api.getFilterModel();
  for (const field of Object.keys(filterState)) {
    if (filterState[field].filterType === 'multi') {
      // [0] = text filter [1] = set filter, either could be null if unused
      if (filterState[field].filterModels[1] && filterState[field].filterModels[1].values.length > 25) {
        toastr.error('Error', `Unable to save layout. col:${field} set filter has too many items selected (25 max).`);
        return;
      }
    }
  }

  const values = {
    pageName: reportConfig.reportName,
  };

  if (reportConfig.userSettings.layout) {
    const { id, name, description, isPublic } = reportConfig.userSettings.layout;
    values.id = id;
    values.name = name;
    values.description = description;
    values.isPublic = isPublic;
  }

  if (dynamicReport) {
    values.options = getOptionsForLayoutHash();
    // Pair dynamic report layout saves with a sha1 hash of the report options
    values.optionsHash = hashOptions();
  }

  // Legacy layout saves included a "s" key for the sort model.  That's now included in column state.
  // The loadLayout routine supports loading those older layouts where "s" was saved separately.
  values.layout = {
    c: gridOptions.columnApi.getColumnState(),
    f: gridOptions.api.getFilterModel(),
  };

  if (headersToggledFromDefaultConfig) {
    // a report has at least 1 column, so sneak our toggle header flag in on the
    // first column's state (which will apply to all columns on loadLayout)
    if (verticalHeadersDefault) {
      values.layout.c[0].blazeForceHorizontalHeader = true;
    } else {
      values.layout.c[0].blazeForceVerticalHeader = true;
    }
  }

  modal.open({
    title: 'Save Layout',
    message: (
      <>
        {dynamicReport && (
          <Alert variant="warning">
            Since this is a dynamic report, different data columns may be shown based on the report options selected
            when running the report. Any layout saved here will be paired with the specific report options you used to
            run the report. The saved layout will only be available when the dynamic report is ran with the same
            options. Note some options such as To/From dates are not considered when pairing saved layouts to the
            dynamic report options.
          </Alert>
        )}
        <SaveGridLayoutForm
          values={values}
          onCancel={() => modal.close()}
          onSubmit={gridLayout => {
            reloadPageOnRerun = true;
            setActiveLayout(gridLayout);
            modal.close();
            toastr.success('Success!', 'Report layout saved.');
          }}
        />
      </>
    ),
    hidePrint: true,
    headerClass: 'primary',
    hideFooter: true,
  });
}

function setActiveLayout(layoutObj) {
  if (!layoutObj) {
    activeLayoutId = null;
    reportConfig.userSettings.layout = null;
    hide(deleteLayoutButton);
    layoutMenuHeader.innerHTML = '';
    resetGrid();
  } else {
    activeLayoutId = layoutObj.id;
    reportConfig.userSettings.layout = layoutObj;
    layoutMenuHeader.innerHTML = `Layout: ${layoutObj.name}`;
    show(deleteLayoutButton);
  }

  if (!dynamicReport) {
    // This is a no-op when no layout selection was present during report options render.
    $('#optionLayoutId').selectpicker('val', activeLayoutId ?? 'default');
  }
}

// Simply close sharelink modal
// Evented when user hits Cancel on share modal
function shareCancel() {
  shareModal.close();
}

// generate a share link and pop a modal to let the user copy it to clipboard
function shareLink() {
  // property names kept purposefully terse for shorter link string
  const linkObj = {
    r: reportConfig.reportName, // report
    b: null, // branchesSeed
    o: [], // optionsSeed
  };

  // we need only save the option values, not the other details
  // includes hidden options
  _.forEach(reportOptions, (v, k) => {
    linkObj.o[k] = v.value;
  });

  // include branch selection - receiving users will only auto-select branches
  // they have permissions for
  if (multibranchAvailable) {
    linkObj.b = [];
    const branchOptions = document.getElementById('multibranchSelection').options;
    for (let i = 0; i < branchOptions.length; i++) {
      if (branchOptions[i].selected) {
        linkObj.b.push(branchOptions[i].value);
      }
    }
  }

  const base64link = btoa(JSON.stringify(linkObj));
  shareLinkInput.value = `${window.location.href.replace(window.location.search, '')}?opts=${base64link}`;
  shareModal.open();
}

// report is being ran with a share link, auto-drive the report module accordingly
// this is ran by init() if a share link is detected in the URL
function shareLinkRun() {
  // extract link from query string
  usingShareLink = true;
  const base64link = window.location.search.substring(6);
  const linkObj = JSON.parse(atob(base64link));

  // prepopulate the report options but allow user of the share link to alter if desired
  reportNameInput = linkObj.r;

  const seed = {
    optionsSeed: linkObj.o,
    branchesSeed: linkObj.b,
  };

  showOptions(seed);
}

function shopStatusLocationEdit(params) {
  // prevent recursion bomb on API oldValue reversion error
  if (shopStatusLocationEditError) {
    shopStatusLocationEditError = false;
    return;
  }

  // no-op
  if (params.newValue === params.oldValue) {
    return;
  }

  const postBody = {
    roNo: params.data.roNo,
    location: params.newValue,
    ppc: getPPC(),
  };

  Api.post('report/shopstatuslocationupdate', postBody)
    .then(res => {
      if (res.data !== 200) {
        throw new Error();
      }
      onFilterChanged(); // update widgets real time
    })
    .catch(() => {
      shopStatusLocationEditError = true;
      params.node.setDataValue('location', params.oldValue);
      toastr.error('Error!', `Unable to update location data for RO# ${params.data.roNo}.  Try again later.`);
    });
}

function shopStatusPromisedEdit(params) {
  // prevent recursion bomb on API oldValue reversion error
  if (shopStatusPromisedEditError) {
    shopStatusPromisedEditError = false;
    return;
  }

  // no-op
  if (params.newValue === params.oldValue) {
    return;
  }

  // Massage date into proper YYYY-MM-DD if possible, fail on error.
  let newValue = params.newValue.trim();
  if (newValue !== '') {
    newValue = moment(newValue).format('YYYY-MM-DD');
  }

  // Bad date?  Revert value and pop error toastr.
  if (newValue === 'Invalid date') {
    shopStatusPromisedEditError = true;
    toastr.error('Error!', 'Invalid date format specified.  Please try again.');
    params.node.setDataValue('promiseDate', params.oldValue);
    return;
  }

  const postBody = {
    roNo: params.data.roNo,
    promiseDate: newValue,
    ppc: getPPC(),
  };

  Api.post('report/shopstatuspromisedateupdate', postBody)
    .then(res => {
      if (res.data !== 200) {
        throw new Error();
      }
      onFilterChanged(); // update widgets real time
    })
    .catch(() => {
      shopStatusPromisedEditError = true;
      params.node.setDataValue('promiseDate', params.oldValue);
      toastr.error('Error!', `Unable to update promise date for RO# ${params.data.roNo}.  Try again later.`);
    });
}

function showGraphs() {
  if (_.has(widgets, reportConfig.reportName)) {
    // at least 1 widget?

    const widgetCount = widgets[reportConfig.reportName].length;

    // exactly 1 widget, no need for flickity
    if (widgetCount === 1 && _.has(widgets, `${reportConfig.reportName}.0`)) {
      graphsToggled = true;
      graphsContainer.style.display = 'block'; // block before chart render to prevent flicker
      graphsContainer.style.marginBottom = '15px';

      switch (widgets[reportConfig.reportName][0].type) {
        case 'amchart':
          const chartConfigJSON = widgets[reportConfig.reportName][0].options;
          const dataProviderTransform = widgets[reportConfig.reportName][0].transforms.dataProvider;
          const dataProvider = dataProviderTransform(rowDataTyped);
          chartConfigJSON.dataProvider = dataProvider;

          chartConfigJSON.titles = [
            {
              text: _.get(widgets[reportConfig.reportName][0], 'title', ''),
              size: 18,
              alpha: 0.6,
            },
          ];
          chartConfigJSON.fontFamily = 'inherit';

          if (_.has(widgets[reportConfig.reportName][0], 'transforms.graphs')) {
            const graphs = widgets[reportConfig.reportName][0].transforms.graphs(rowDataTyped);
            chartConfigJSON.graphs = graphs;
          }

          // webpack compatibility - see require at head of module
          chartConfigJSON.pathToImages = '/img/amcharts/';

          chartConfigJSON.export = _.clone(exportAmChartsConfig);
          chartConfigJSON.export.fileName = chartConfigJSON.titles[0].text
            ? `${reportConfig.reportName} - ${chartConfigJSON.titles[0].text}`
            : reportConfig.reportName;

          chartObjs.push({
            chart: AmCharts.makeChart('graphsContainer', chartConfigJSON),
            dataProviderTransform,
          });

          break;
        case 'mapbox':
          const map = L.mapbox
            .map('graphsContainer')
            .setView([40.718217, -73.998284], 13)
            .addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));
          const mapObj = {
            map,
            hook: widgets[reportConfig.reportName][0].hook,
          };
          mapboxObjs.push(mapObj);
          showMapPoints();
          break;
        default:
          break; // do nothing
      }
    } else if (widgetCount > 1) {
      graphsToggled = true;
      graphsContainer.style.display = 'block';

      // dynamically render flickity container divs
      let carouselCells = '';
      for (let i = 0; i < widgetCount; i++) {
        carouselCells += `<div class="carousel-cell" id="graph${i}"></div>`;
      }
      graphsContainer.innerHTML = `<div id="graphsSlider">${carouselCells}</div>`;
      graphsContainer.style.marginBottom = '35px';

      // dynamically render widgets into flickity divs
      let i = 0;
      widgets[reportConfig.reportName].forEach(widget => {
        switch (widget.type) {
          case 'amchart':
            const chartConfigJSON = widget.options;
            const dataProviderTransform = widget.transforms.dataProvider;
            const dataProvider = dataProviderTransform(rowDataTyped);
            chartConfigJSON.dataProvider = dataProvider;

            chartConfigJSON.titles = [
              {
                text: _.get(widget, 'title', ''),
                size: 18,
                alpha: 0.6,
              },
            ];
            chartConfigJSON.fontFamily = 'inherit';

            if (_.has(widget, 'transforms.graphs')) {
              const graphs = widget.transforms.graphs(rowDataTyped);
              chartConfigJSON.graphs = graphs;
            }

            // webpack compatibility - see require at head of module
            chartConfigJSON.pathToImages = '/img/amcharts/';

            chartConfigJSON.export = _.clone(exportAmChartsConfig);
            chartConfigJSON.export.fileName = chartConfigJSON.titles[0].text
              ? `${reportConfig.reportName} - ${chartConfigJSON.titles[0].text}`
              : reportConfig.reportName;

            chartObjs.push({
              chart: AmCharts.makeChart(`graph${i}`, chartConfigJSON),
              dataProviderTransform,
            });
            break;
          case 'mapbox':
            const map = L.mapbox
              .map(`graph${i}`, 'mapbox.streets', { attributionControl: false })
              .setView([40.718217, -73.998284], 13);
            const mapObj = {
              map,
              hook: widget.hook,
            };
            mapboxObjs.push(mapObj);
            showMapPoints();
            break;
          case 'template':
            document.getElementById(`graph${i}`).innerHTML = widget.render(rowDataTyped);
            break;
          default:
            break; // do nothing
        }

        i++; // increase flickity graphN
      });

      // init flickity
      new Flickity(document.getElementById('graphsSlider'), {
        cellAlign: 'left',
        contain: true,
        draggable: false,
        wrapAround: true,
      });
    }
  } // else no widgets exist for this report
}

function showMapPoints() {
  // init map data here then call hook
  const widgetData = { data: {} };
  for (const zipcode of Object.keys(zipcodes)) {
    if (zipcode === '') {
      continue;
    }

    const latitude = _.get(geocodes, `${zipcode}.0`, null);
    const longitude = _.get(geocodes, `${zipcode}.1`, null);

    // only map this zip if a valid (non-null) lat/long returned from server
    if (latitude && longitude) {
      widgetData.data[zipcode] = {
        c: zipcodes[zipcode],
        latlng: [latitude, longitude],
      };
    }
  }

  if (_.isEmpty(widgetData.data)) {
    console.error('No geocode data found.  Please ensure geocodes are installed.');
  }

  // at least one mappable zip in this result set?
  if (Object.keys(widgetData.data).length > 0) {
    mapboxObjs.forEach(mapboxObj => {
      mapboxObj.hook(mapboxObj.map, widgetData);
    });
  }
}

/* Optionally call this with a seed containing an optionsSeed and branchesSeed
  (currently used only by shareLinkRun())
*/
function showOptions(seed = null) {
  // subsequent report run on the same report?
  if (reportConfig !== null) {
    subsequentReportRun = true;
    // do we have a reason to pop an options modal in the first place?
    if (cacheDisabled && !hasVisibleOptions && !multibranchAvailable) {
      optionsSaveAndRun(); // essentially emulates an options modal render + save click
    } else {
      // Does the report options modal layout selections need rehydration?
      if (reloadPageOnRerun && !dynamicReport) {
        window.location.reload();
        return;
      }

      optionsModal.open();
    }
  } else {
    // initial option load
    fetchReportConfig(reportNameInput)
      .then(data => {
        if (data.config === null) {
          throw 'page not found';
        } else {
          reportConfig = data;

          // check for a saved layout application
          activeLayoutId = _.get(reportConfig, 'userSettings.layout.id', null);

          // check for seeds either via auto-run (shareLink) or user profile saves
          let branchesSeed = null;
          let optionsSeed = null;

          // were we seeded directly (i.e., via shareLinkRun()) ?
          if (seed) {
            branchesSeed = _.get(seed, 'branchesSeed', null);
            optionsSeed = _.get(seed, 'optionsSeed', null);
          } else {
            // otherwise, check the user profile for saved options
            branchesSeed = _.get(reportConfig, 'userSettings.reportOptions.branchesSeed', null);
            optionsSeed = _.get(reportConfig, 'userSettings.reportOptions.optionsSeed', null);
            if (optionsSeed) {
              seededOptionsFromUserProfile = true;
            }
          }

          // page.Report.cache.disabled is true, disable UI for cache too.  in the event
          // no other visible options exist (including multibranch), the options modal will
          // never pop, and the report will immediately run (WEBRO2, for example)
          cacheDisabled = _.get(reportConfig, 'config.page.Report.cache.disabled', false);

          // Suppress leading $ on all currency values for the entire report (per Gail for accountants)
          dollarsignDisabled = _.get(reportConfig, 'config.page.Report.dollarsign.disabled', false);

          // Allow YAML author to disable multibranch support for this report.  If disabled, only
          // the default branch will be available (unless the user manually switches branches, etc.).
          multibranchDisabled = _.get(reportConfig, 'config.page.Report.multibranch.disabled', false);

          // Allow YAML author to disable sorting for all columns.
          sortingDisabled = _.get(reportConfig, 'config.page.Report.sorting.disabled', false);

          // Auto expand all rows when grouping
          autoExpand = _.get(reportConfig, 'config.page.Report.autoexpand', false);

          // if page.Report.autorefresh exists, we'll set an interval to poll for data
          // at the specified number of seconds (shop status, mechanic status)
          autoRefreshSecs = _.get(reportConfig, 'config.page.Report.autorefresh', 0);

          // # of seconds for change highlight to remain on screen
          highlightSecs = _.get(reportConfig, 'config.page.Report.highlight', 5);

          // probably only used by reports with sparklines that need more space, see getRowHeight()
          rowHeightOverride = _.get(reportConfig, 'config.page.Report.rowheight');

          // this option determines if ag-grid's range selection charts are turned on (default off)
          rangecharts = _.get(reportConfig, 'config.page.Report.rangecharts', true);

          // vertical header support
          if (_.get(reportConfig, 'config.page.Report.verticalheaders', false)) {
            verticalHeadersDefault = true;

            // add appropriate CSS class to griddiv (reset on each report component mount)
            const el = document.getElementById('gridDiv');
            el.classList.add('ag-vertical-headers');

            // override header height, if set (defaults to 150px) - horizontal headers height remains null
            headerHeight = _.get(reportConfig, 'config.page.Report.verticalheaderheight', 150);
          }

          // Drilldown component uses reportConfig data
          Drilldown.setReportConfig(reportConfig);

          if (reportConfig.widgets) {
            // eval namespaced widget code
            eval(reportConfig.widgets);

            /* reportConfig.widgets may also contain stylehooks, and is thus a partial misnomer
               WEBAR4 & WEBPI4, for example, contain only style hooks.
               As a result, enable graphs button only if actual widgets exist for this report
            */
            if (_.has(reportModule, `widgets.${reportConfig.reportName}`)) {
              graphsButton.style.display = 'inline-block';
            }
          }

          if (!_.has(data, 'config.page.Report')) {
            throw 'not a report';
          }

          if (_.get(data, 'config.page.Report.dynamic', false) === true) {
            dynamicReport = true;
          }

          // this renders input controls into the DOM, but not visible unless optionModals.open()
          renderOptionsFormModal(optionsSeed, branchesSeed);

          if (cacheDisabled && !hasVisibleOptions && !multibranchAvailable) {
            optionsSaveAndRun();
          } else {
            optionsModal.open();
          }
        }
      })
      .catch(error => {
        if (error === 'fetch error') {
          toastr.error('Error!', 'Network error.  Please try again later.');
        }
        if (error === 'page not found') {
          toastr.error('Error!', 'Page configuration not found.');
        }
        if (error === 'not a report') {
          toastr.error('Error!', 'Page requested is not a report.');
        }
      });
  }
}

/* This draws the optionDiv (which shows the user the current option settings
   just above the results display. optionsDiv is DIFFERENT from the optionsModal).

   Pass it what HTML you want rendered.
*/
function showOptionsSetDiv(innerHTML) {
  optionsSetDiv.innerHTML = innerHTML;
  optionsSetDiv.style.display = 'block';
}

// Evented when user presses Show Results button.
// Based on the current options (reportOptions), fetches report data, parses it, and loads the grid.
function showResults() {
  resetResults();
  calculateGridHeight(); // ag-grid 10.x optimization - prevents control row flicker on initial render
  waitingIndicator(true);

  fetchReportData()
    .then(res => {
      // fast short circuit logic to detect no data
      // NO.DATA case has non-printables, hence indexOf
      if (res === 'NO DATA') {
        noDataDiv.style.display = 'block';
        waitingIndicator(false);
      } else {
        // load the grid
        // most grid features are enabled here.  reference ag-grid documentation.
        gridOptions = {
          defaultColDef: {
            resizable: true,
            sortable: true,
          },
          animateRows: false,
          cellFlashDelay: highlightSecs * 1000,
          columnDefs,
          enableBrowserTooltips: true,
          enableCellChangeFlash: true,
          enableCharts: rangecharts,
          enableRangeSelection: true,
          excelStyles,
          getContextMenuItems: Drilldown.getContextMenuItems,
          getMainMenuItems,
          getRowHeight,
          getRowStyle,
          // If itemId is set on a column (such as ro #), it indicates the column values are used as unique keys to track
          // additions and updates, and to find the row with getRowNode.
          // 10/1/20: An ag bug introduced after 23.0 passes n of undefined on group rows, leading to exceptions, so dance around it
          getRowNodeId: itemId ? n => (n ? n[itemId] : null) : null,
          groupIncludeFooter: true,
          groupSuppressBlankHeader: true, // prevents cell flash when headers blank out on expand
          headerHeight,
          onColumnVisible,
          onFilterChanged,
          pinnedBottomRowData, // if null, empty row will not display on grid
          rowData,
          rowGroupPanelShow: 'always',
          sideBar: {
            toolPanels: [
              {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
              },
              {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                  suppressPivotMode: true,
                  suppressValues: true,
                },
              },
            ],
          },
          sortingOrder: sortingDisabled ? [null] : ['asc', 'desc', null],
          statusBar: {
            statusPanels: [{ statusPanel: 'agAggregationComponent' }],
          },
          suppressAggAtRootLevel: true,
          suppressAggFuncInHeader: true,
          suppressFieldDotNotation: true,
          suppressPropertyNamesCheck: true,
          suppressDragLeaveHidesColumns: true,
        };

        if (autoExpand) {
          gridOptions.onColumnRowGroupChanged = () => {
            // inert if collapseed
            gridOptions.api.expandAll();
          };
        }

        // reset quick filter on a fresh grid
        quickFilterInput.value = '';

        waitingIndicator(false);

        // reset vertical header classes on a fresh run
        if (subsequentReportRun && headersToggledFromDefaultConfig) {
          resetHeaderOrientation();
          headersToggledFromDefaultConfig = false;
        }

        // gridOptions gets mutated by agGrid.Grid to add api methods (strange)
        new Grid(gridDiv, gridOptions, { modules: AllModules });

        actionButtonsDiv.style.display = 'inline-block';
        quickFilterDiv.style.display = 'block';
        rowCountSpan.innerHTML = `${numberWithCommas(rowCount)} Results`;

        // set height of grid to maximize remaining viewport space - note:  this is NOT for columns.
        // also add an event listner for window.resize in init() to autoSizeGrid()
        autoSizeGrid();

        // due to deficiencies in ag-grid, we must apply our custom aggFuncs AFTER the grid is initialized,
        // if we assign aggFuncs directly to the columnDefs, they are lost after any column state resets
        // https://ag-grid.com/forum/showthread.php?tid=5173 (lame)
        gridOptions.api.addAggFunc('groupAggFuncCurrency', groupAggFuncCurrency);
        gridOptions.api.addAggFunc('groupAggFuncDouble', groupAggFuncDouble);
        applyAggFuncs();

        // move any columns which have a moveto specification in the YAML
        for (const index of Object.keys(columnDefs)) {
          if (columnDefs[index].moveto !== null) {
            // calculate the fromIndex after any movetos already applied!
            const columnState = gridOptions.columnApi.getColumnState();
            const fromIndex = _.findIndex(columnState, o => o.colId === columnDefs[index].field); // eslint-disable-line
            gridOptions.columnApi.moveColumnByIndex(fromIndex, columnDefs[index].moveto);
          }
        }

        // apply saved layout if it exists
        loadLayout();

        // setup auto-refresh interval if specified in the YAML
        // note this interval starts after we've had an initial grid load
        if (autoRefreshSecs !== 0) {
          autoRefreshIntervalObj = setInterval(autoRefreshFunc, autoRefreshSecs * 1000);
        }

        // async fetch geolocation information for a subset of reports (for mapbox)
        // we cache this exactly once from the server, then apply filters all client side
        if (
          _.includes(
            ['AAR6A', 'AAR6B', 'AAR6C', 'ACU11', 'APR4', 'AST5', 'PCR8', 'PMR4', 'PMR4A', 'SCU7'],
            reportConfig.reportName
          )
        ) {
          // submit server request for geolocation data here - cache client side for future filtered lookups
          zipcodes = [];
          const dataLength = rowData.length;
          for (let i = 0; i < dataLength; i++) {
            zipcodes.push(rowData[i].zipcode);
          }
          zipcodes = _.countBy(zipcodes, zipcode => {
            // sanitize, unique filter, and count the codes client side
            // remove spaces
            if (~zipcode.indexOf(' ')) {
              zipcode = zipcode.replace(/ /g, '');
            }
            // extract only portion before . if present
            if (~zipcode.indexOf('.')) {
              zipcode = zipcode.split('.')[0];
            }
            // extract non-extended portion of US zipcodes that provide it
            if (~zipcode.indexOf('-')) {
              zipcode = zipcode.split('-')[0];
            }
            return zipcode;
          });

          // At this point we have unique, sanitized, and counted zip codes, now pull the geodata.
          // This will be async and should retrieve the data before a user tries to load a mapbox
          // (though the map routine will wait if data has not yet loaded).
          fetchGeoCodes(Object.keys(zipcodes));
        }
      }
    })
    .catch(error => {
      // fetchReportData error
      waitingIndicator(false);
      if (error === 'config error') {
        toastr.error('Error!', 'Report config error.');
      } else if (error === 'fetch error') {
        toastr.error('Error!', 'Network error. Please try again later.');
      } else if (error === 'parse error') {
        toastr.error('Error!', 'Error parsing data.');
      } else {
        // any error thrown in previous .then directly above
        console.log(error);
        toastr.error('Error!', 'Grid data processing error.');
      }
    });
}

// Evented by user pressing toggle graphs button
function toggleGraphs() {
  if (graphsToggled) {
    clearGraphs();
  } else {
    showGraphs();
  }
}

function toggleVerticalHeaders() {
  headersToggledFromDefaultConfig = !headersToggledFromDefaultConfig;
  const el = document.getElementById('gridDiv');

  if (el.classList.contains('ag-vertical-headers')) {
    gridOptions.api.setHeaderHeight(25);
  } else {
    gridOptions.api.setHeaderHeight(_.get(reportConfig, 'config.page.Report.verticalheaderheight', 150));
  }

  // Height must be set before applying the class or weirdness happens
  el.classList.toggle('ag-vertical-headers');
}

function updatePersistedReportOptions() {
  // Persist active layout ID or next reload (if layout selection was available during this report options render)
  // Only static reports allow layout selection at report option time
  const layoutOptionId = document.getElementById('optionLayoutId');
  if (layoutOptionId) {
    Api.post('user-grid-layouts', {
      pageName: reportConfig.reportName,
      optionsHash: null,
      layoutId: layoutOptionId.value === 'default' ? '' : layoutOptionId.value,
    }).catch(err => {
      console.error('Error persisting report layout id.');
      console.error(err.message);
    });
  }

  // Do we need to save any other report options?
  const saveOptionsEl = document.getElementById('saveOptionsForNextRun');
  if (!saveOptionsEl) {
    // we're done here if no other options need persistance
    return;
  }

  let postBody = null;

  // request to persist?
  if (saveOptionsEl.checked) {
    // if we made it here, there is at least 1 visible option
    let branchesSeed = null;
    if (multibranchAvailable) {
      branchesSeed = [];
      const branchOptions = document.getElementById('multibranchSelection').options;
      for (let i = 0; i < branchOptions.length; i++) {
        if (branchOptions[i].selected) {
          branchesSeed.push(branchOptions[i].value);
        }
      }
    }

    const optionsSeed = [];
    // includes hidden options
    _.forEach(reportOptions, (v, k) => {
      optionsSeed[k] = v.value;

      // Support the optional "Today" feature on date fields (see YAML config)
      if (v.type === 'date' && v.todaycheckbox) {
        if (document.getElementById(`option${k}today`).checked) {
          optionsSeed[k] = 'TODAY';
        }
      }

      if (v.type === 'date' && v.yesterdaycheckbox) {
        if (document.getElementById(`option${k}yesterday`).checked) {
          optionsSeed[k] = 'YESTERDAY';
        }
      }
    });

    postBody = {
      reportName: reportConfig.reportName,
      options: {
        branchesSeed,
        optionsSeed,
      },
    };

    // otherwise, clear any saved options IF NOT a share link run
    // and visible options / branch selection exist to save in the first place
  } else if (!usingShareLink && (hasVisibleOptions || multibranchAvailable)) {
    postBody = {
      reportName: reportConfig.reportName,
      clear: true,
    };
  }

  // only hit the API if we have a reason to
  if (postBody) {
    Api.post('report/options', postBody)
      .then(res => {
        if (res.status !== 200) {
          throw new Error();
        }
      })
      .catch(() => {
        console.error('Unable to persist report options to user profile.');
      });
  }
}

// Applies any option validations and pops form errors where applicable.
// Returns true if the form passes all known validations.
// reportOptions0..N correlate to option0..N form controls and formError0..N error divs
function validateOptions() {
  let isValid = true; // unless proven invalid

  reportOptions.forEach((option, i) => {
    if (!_.includes(['date', 'number', 'search', 'text'], option.type)) {
      return;
    }

    const optionEl = document.getElementById(`option${i}`);
    const formError = document.getElementById(`formError${i}`);

    // first check for required validation
    if (option.required && optionEl.value.trim() === '') {
      formError.style.display = 'block';
      formError.innerHTML = 'Required';
      isValid = false;
      return; // no need to check other validations for this option if this fails
    }

    // type specific validations
    switch (option.type) {
      case 'date':
        // make sure this follows an acceptable date format of m-d-y (with or without leading zeroes)
        if (!!optionEl.value && !optionEl.value.match('^[0-3]?[0-9][-][0-3]?[0-9][-](?:[0-9]{2})?[0-9]{2}$')) {
          formError.style.display = 'block';
          formError.innerHTML = 'Invalid Date Format';
          isValid = false;
        }
        break;
      case 'number': // should be enforced by min/max on the input control in modern browsers
        break;
      case 'text':
        // apply any pattern (regex) validations here)
        // remove leading/trailing "/" if applying pattern
        const pattern = _.get(option, 'pattern', '');
        if (!!optionEl.value && pattern && !optionEl.value.match(pattern.slice(1, -1))) {
          formError.style.display = 'block';
          formError.innerHTML = 'Invalid Input';
          isValid = false;
        }
        break;
      default:
        break;
    }
  });

  // if the user has the option to select multiple branches, make sure he/she picked at least one
  if (multibranchAvailable) {
    const branchOptions = document.getElementById('multibranchSelection').options;
    const formError = document.getElementById('formErrorMultibranchSelection');
    const isBranchSelected = () => {
      let branchSelected = false;
      for (let i = 0; i < branchOptions.length; i++) {
        if (branchOptions[i].selected) {
          branchSelected = true;
        }
      }
      return branchSelected;
    };

    $('#multibranchSelection').off('changed.bs.select'); // prevent duplicative event handlers
    if (!isBranchSelected()) {
      formError.style.display = 'block';
      formError.innerHTML = 'Select At Least 1 Branch';
      isValid = false;

      // watch for the user to clear the error
      $('#multibranchSelection').on('changed.bs.select', () => {
        if (isBranchSelected()) {
          formError.style.display = 'none';
        } else {
          formError.style.display = 'block';
        }
      });
    }
  }

  return isValid;
}

/* Turns on/off the waiting indicator.
   Enables/Disables "Show Results" button accordingly.
   For fast reports taking < 250ms, this will never show.

   waitingInterval saved in module state
*/
function waitingIndicator(enableWaiting = false) {
  if (enableWaiting) {
    showOptionsButton.disabled = true;
    const start = new Date().getTime();
    waitingInterval = setInterval(() => {
      const current = new Date().getTime();
      const waitingSeconds = Math.floor((current - start) / 1000);
      waitingSecs.innerHTML = `${waitingSeconds}s`;
      waitingDiv.style.display = 'block';
    }, 250);
  } else {
    showOptionsButton.disabled = false;
    waitingDiv.style.display = 'none';
    clearInterval(waitingInterval);
  }
}

// global exports namespaced to reportModule - widgets also anchor here
// keep this as minimal as possible - used by drilldowns, etc.
window.reportModule = {
  clearError,
  debug,
  getShopStatusCodes,
  getPPC,
  getReportOptions,
  isAlternateBranchesRequested,
  moment,
  numberWithCommas,
  renderHooks,
  sparklineOptions,
  styleHooks,
  widgets,
  wordwrap,
};

// es6 exports used by react component
export default {
  archive,
  autoSizeColumns,
  clearAllFilters,
  clearQuickFilter,
  deleteLayout,
  destroy,
  exportCSV,
  exportPDF,
  exportXLS,
  fitAllColumns,
  init,
  loadLayoutDialog,
  showOptions,
  optionsCancel,
  optionsSaveAndRun,
  quickFilter,
  resetGrid,
  saveLayout,
  shareCancel,
  shareLink,
  toggleGraphs,
  toggleVerticalHeaders,
};
